export default {
  locale_name: 'English',
  facebook: 'Facebook',
  twitter: 'Twiter',
  insta: 'Instagram',
  telegram: 'Telegram',
  buy: 'Buy',
  sell: 'Sell',
  login: 'Login',
  sign_up: 'Sign Up',
  profile: 'My Page',
  logout: 'logout',
  home: 'Home',
  asset: 'Asset',
  code: 'Code',
  buy_btn: 'Buy',
  not_allow: 'Imposibility',
  sell_btn: 'Sale',
  trade: 'Transaction',
  select: 'Select',
  cancel: 'Cancel',
  deposit: 'Deposit',
  withdraw: 'Withdraw',
  request: 'Request',
  account: 'Account',
  status: 'Status',
  allow: 'Allow',
  disallowed: 'Not Allowed',
  modify: 'Modification',
  auto: '(Automatic Input)',
  inquiry: 'Inquiry',
  no_select: '(No Selection)',
  confirm: 'Confirm',
  upload_btn: 'Drop or click on the file here.',
  continue_entry: 'Enter "[+:verification]" below to continue.',
  toasted_msg: {
    confirm: 'It has been confirmed.',
    changed: 'It has been changed.',
    withdrawal: 'You has been withdrawn.',
    register: 'You has been registered.',
    title: 'Notification',
    exchange: 'Direct Exchange Successfully Processed.',
    search: 'It has been inquired.',
    deposit_request: 'The deposit has been requested.',
    withdraw_request: 'The withdrawal has been requested.',
    create_account: 'It has been opened.',
    modify: 'It has been modified.',
    cancel: 'It has been canceled.',
    trade_confirm: 'The transaction has been confirmed.',
    trade_reject: 'Your transaction has been rejected.',
    copy: 'It has been copied.',
    nice_msg:
      'If pop-up is not allowed in the browser settings, self-authentication will not proceed normally.',
    nice_title: 'Announcement',
    nice_error: 'You cannot authenticate yourself.',
    no_transfer: 'There is no exchange information.',
    email_auth: 'Email authentication completed successfully.',
    email_auth_send: 'A authentication email has been sent.',
    kyc_withdraw: 'Account authentication succeeded.',
    not_allow_trade: 'The transaction is not active.',
  },
  header: {
    C2C_enroll: 'C2C Registration',
    direct_buy: 'Direct Purchase',
    direct_sell: 'Direct Sales',
    wallet_manage: 'Wallet Management',
    C2C_list: 'C2C History',
    B2C_list: 'B2C History',
    withdrawal: 'Deposit/Withdrawal',
    trade_list: 'Transaction History',
    customer_service: 'Customer Service',
  },
  home_msg: {
    about_title: 'ABOUT JanoPay',
    about_title_2:
      'JanoPay is with the development of the Korean blockchain industry.',
    about_line_1_1:
      'A new concept cryptocurrency exchange in the form of a real spot trading and exchange',
    about_line_1_2: 'Selected carefully and listed verified cryptocurrency',
    about_line_1_3: 'Global cryptocurrency exchange with various languages',
    about_line_2_1:
      'Reliable security based on large-scale distributed architecture design and DDOS attack defense systems',
    about_line_2_2:
      'Provides a reliable trading environment and asset complementary management solution',
    about_line_3_1:
      'Gain payment and transaction reliability through our own network',
    about_line_3_2: 'Build trust with clients and periodically update services',
    about_line_4_1:
      'Integrated crypto platform that connects you to take advantage of your encrypted assets without online and offline constraints',
    about_sub_1: 'Key Point',
    about_sub_1_1:
      'In line with the increasing trend of global regulations, the Financial Action Task Force (FATF) and Virtual Asset Service Providers (VASP) are recommended to prevent money laundering and block terrorist financing',
    about_sub_1_2:
      'Cryptocurrency holders support direct transactions such as C2C, B2C in line with the increasing proportion of OTC and the decline in reliability of trusted exchanges',
    about_sub_2: 'Various Content',
    about_sub_2_1: 'Increase accessibility for offline use by leveraging kiosk',
    about_sub_2_2:
      'Maximize safety and convenience by making a card-type wallet',
    about_sub_2_3: 'Global open market shopping mall operation',
    about_sub_3: 'Global Vision',
    about_sub_3_1:
      'Beyond Japan, China and Southeast Asia services and Europe services will be expanded',
    about_sub_3_2:
      'JanoPay, a global cryptocurrency exchange that leads a new era by distributing kiosk devices introduced in Japan to Vietnam, the Philippines, and other countries',
    about_side_1: 'World/s Leading Cryptocurrency Exchange',
    about_side_1_1: 'Fast, secure direct (C2C) 24 hour trading service support',
    about_side_1_2:
      'Provide the safety of cryptocurrency transactions by providing escrow system',
    about_side_1_3:
      'B2C support for quick transactions using JanoPay without intermediate steps',
    about_side_1_4:
      'Reduce OTC (over-the-counter) hassle and fee burden, and provide secure and easy direct transaction services 24 hours a day offline',
    login_register: 'Login/Sign Up',
    trade_guide: 'View transaction guide',
    app_down_1: 'Download the App',
    app_down_2: 'Various coins, real-time quotations, and simple transactions',
    app_down_3:
      'Convenient transaction services are available anytime, anywhere',
  },
  footer: {
    about: 'Introduction',
    career: ' Load Map',
    escrow: 'Escrow Deal',
    press: 'Media',
    partner: 'If you want to be our partner',
    help: 'Customer Support',
    chat: 'Live Chat',
    blog: 'Blog',
    phone: 'Contact Number',
    social: 'Social',
  },
  footer_link: {
    about_title: 'Company Introduction',
    msg_about_1:
      'JanoPay stands for Japanese Anonymous Number One Pay and is a cryptocurrency exchange. In line with the growing trend of global regulations, the Financial Action Task Force (FATF) and Virtual Asset Service Providers (VASP) are complying with the anti-money laundering and anti-terrorist financing regulations and supporting users/ smooth transactions and safe transactions.',
    msg_about_2:
      'Cryptocurrency holders are focusing on OTC (over-the-counter transactions) and the reliability of exchanges is deteriorating. In line with the changing times, JanoPay is supporting direct transactions like C2C B2C. 암호화폐 보유자들은 장외거래(OTC)에 비중을 두고 있으며 거래소들의 신뢰성이 저하되고 있습니다. 변하고 있는 시대에 맞추어 JanoPay는 C2C B2C와 같은 즉시거래를 지원하고 있습니다.',
    msg_about_3:
      'JanoPay/s ONE CARD combines cold wallet systems to store virtual currency on network-blocked hardware devices and handle it offline for security.',
    msg_about_4:
      'ONE CARD can be used for kiosk devices distributed in Japan, and JanoPay exchange can be used offline',
    msg_about_5:
      'In addition, kiosk devices allow you to enjoy realistic contents such as cash withdrawal and deposit, movie ticket reservation, and JanoPay shopping mall.',
    msg_about_6:
      'JanoPay supports various languages such as English, Chinese, and Japanese, and will lead the trend of electronic finance that fits the times by distributing kiosk devices not only in Japan but also abroad.',
    escrow_big_title: 'Escrow Deal',
    msg_escrow_1:
      'Escrow service is an asset protection service that allows transactions between sellers and buyers to take place safely and smoothly.',
    msg_escrow_2: '-Transaction procedure-',
    msg_escrow_3:
      '1. When a member charges KRW, he/she keeps KRW in the bank (PG)',
    msg_escrow_4:
      '2. When a charged member requests a purchase, he or she deposits it to the seller with the money entrusted to the bank (PG).',
    msg_escrow_5:
      '3. If the seller checks the money and the buyer checks the coin, the transaction is established.',
    msg_escrow_6:
      '4.If a problem occurs, resolve it based on evidence provided by both sides.',
    msg_escrow_7: 'JanoPay strives to protect your assets.',
  },
  account_form: {
    id_place: 'Please enter your ID',
    pw_place: 'Please enter your password.',
    forgot_pw: 'Did you forget your password?',
    confirm_pw: 'Confirm Password',
    name_place: 'Please enter your name',
    email_place: 'Please enter your email.',
    agree: 'Agree.',
    all_agree: 'All Agree',
    find_pw: 'Find password',
    code_place: 'Please enter the code sent',
  },
  trade_page: {
    b2c_trade: 'Making B2C transactions',
    select_asset: 'Please select an asset',
    select_coin: 'Please select a coin',
    c2c_trade: 'C2C transactions',
    buy_asset: 'Assets to buy',
    sell_asset: 'Assets to sell',
    purchaser_name: 'Buyer name',
    seller_name: 'seller name',
    amount: 'Quantity',
    limit_buy: 'Minimum buy quantity',
    limit_sell: 'Minimum sell quantity',
    total_sell_price: 'Total sale quantity',
    buy_price: 'Purchase Price',
    sell_price: 'Sales Price',
    regdate: 'Last information modification date',
    sell_register: 'Sell Registration',
    buy_register: 'Buy Registration',
    select_c2c_info: 'Selected Sell Disclosure Information',
    seller_info: 'Seller Information',
    market_select: 'Market selection',
    market_title: 'Market Title',
    sell_price_msg: 'Quantity to sell (0.00000000)',
    min_sell_amount: 'Minimum Sell Quantity',
    min_buy_price: 'Minimum Buy Quantity',
    min_sell_amount_msg: 'Minimum number of purchase from the other party',
    per_sell_price: 'Sales price per piece',
    per_sell_price_msg: 'Set a specified price for 1.00000000 pieces.',
    per_sell_price_msg2:
      'You can set the price you want to receive per unit sales.',
    select_account: 'Select an account to receive',
    withdraw_account: 'Select an account to withdrawal',
    direct_buy_asset: 'Assets to buy immediately',
    direct_sell_asset: 'Assets to sell immediately',
    change_target_asset: 'Assets subject to replacement',
    source_buy_asset: 'Purchase assets',
    source_sell_asset: 'Sales assets',
    target_change_asset: 'Replacement asset',
    b2c_buy_price: 'Purchase price',
    b2c_sell_price: 'Sales Price',
    buy_amount: 'Purchase Quantity',
    sell_amount: 'Sales quantity',
    buy_amount_msg: 'Quantity you want to buy 0.00000000',
    per_price: 'price per piece',
    per_price_msg: 'hold {0}:',
    per_price_msg2: 'The price is automatically displayed.',
    receive_quantity: 'Quantity to receive',
    bill_amount: 'Quantity to be paid',
    b2c_buy_title: 'Buy.',
    b2c_sell_title: 'Sell.',
    b2c_asset: '{0} to {1}',
    b2c_market_price: 'Current price',
    b2c_direct_buy: 'on buy immediately',
    b2c_direct_sell: 'on sell immediately',
    b2c_exchange_amount: 'Currency exchange quantity',
    b2c_amount: 'applied amount',
    b2c_buy: 'Buy with {0}',
    b2c_sell: 'Sell as {0}',
    potential_amount: 'Available quantity',
    holding_amount: 'Unconfirmed sales quantity',
    confirm_amount: 'Confirmed sales quantity',
  },
  page_navigation: {
    first_page: 'First page',
    last_page: 'Last page',
  },
  wallet: {
    asset_value: 'My KRW holdings',
    show_currency: 'View all assets',
    asset_list: 'Assets List',
    wallet_list: 'Account List',
    account_name: 'Account Name',
    account_number: 'Account Number',
    balance: 'Balance',
    withdrawal_register: 'Application for deposit/withdrawal',
    withdrawal_inquiry: 'Deposit/withdrawal application inquiry',
    account_register: 'Account Creation',
    deposit_inquiry: 'Deposit Inquiry',
    withdraw_inquiry: 'Withdrawal Inquiry',
    account_modify: 'Account modification',
    deposit_price: 'Deposit Amount',
    deposit_register: 'Deposit Application',
    withdraw_register: 'Withdrawal Application',
    withdraw_price: 'Withdrawal Amount',
    account_seq: 'Account Unique Number',
    regdate: 'Opening Date',
    hold_balance: 'Suspension Amount',
    selected_asset: 'Selected Assets',
    before_regdate: '(Before Opening)',
    open: 'Open',
    address_title: 'Account Address Information',
    account_address: 'Account Address',
    create_account_address: 'Open account address',
    deposit_msg: 'Deposit {0} from external wallet to my {0} wallet.',
    deposit_msg_1:
      'After receiving 350 approvals (confirmations) on the blockchain, it will be reflected in the {0} transaction wallet.',
    deposit_step_1: 'STEP 1. Check the {0} Memo ID first.',
    deposit_step_1_1: 'My {0} Memo ID',
    deposit_step_1_2:
      'Make sure to indicate your unique Memo ID when you make a deposit {0} {0} transferred without a Memo ID will be lost.',
    deposit_step_1_3: 'Confirmed. View my {0} wallet address.',
    deposit_step_1_btn: 'Create note ID',
    deposit_step_2: 'STEP 2. Please check my wallet address.',
    deposit_step_2_1: 'QR code',
    deposit_step_2_2: 'Wallet Address',
    deposit_step_2_3:
      'The minimum deposit amount is <span style="color:#4a90e2">{0} {1}</span> .',
    deposit_step_2_btn: 'Copy wallet address',
    deposit_msg_2: 'Please Confirm',
    deposit_msg_2_1: 'The above address is for deposit only.',
    deposit_msg_2_2:
      'The total time required to complete the confirmation may be affected by the congestion of the blockchain network, and the congestion of the blockchain according to the cryptocurrency can be found in <span style="color:#4a90e2;cursor:pointer;">here</span>.',
  },
  private: {
    my_deal_list: 'My sales list',
    my_app_list: 'My Purchase history',
    source_asset: 'Original assets',
    target_asset: 'Target assets',
    source_amount: 'Original assets quantity',
    regdate: 'Disclosure date',
    source_max_amount: 'Maximum quantity',
    source_min_amount: 'Minimum quantity',
    max_price: 'Maximum asking price limit',
    min_price: 'Minimum asking price limit',
    close_date: 'Closing Date',
    app_inquiry_cancel: 'Inquire/Cancel of purchase history',
    app_name: 'Buyer name',
    per_price: 'Price per Quantity',
    confirm_reject: 'confirmation/Rejection',
    confirm: 'confirmation',
    reject: 'Rejection',
    fee_amount: 'Total Fee',
    request_cancel: 'Cancellation of application',
    b2c_source_asset: 'Reference asset',
    b2c_target_asset: 'Relative asset',
    b2c_source_amount: 'Reference asset quantity',
    b2c_target_amount: 'Relative assets quantity',
    basic_rate: 'Applied trading standard rate',
    spread_rate: 'Applied spread rate',
    exchange_rate: 'Applied exchange rate',
    source_account: 'Reference asset account number',
    target_account: 'Relative asset account number',
    fee_rate: 'Fee',
    fee_calc: '{0} will be deducted.',
    b2c_buy_asset: 'Purchase assets',
    b2c_sell_asset: 'Sales assets',
    b2c_buy_amount: 'Purchase asset quantity',
    b2c_sell_amount: 'Sales asset quantity',
    b2c_last_buy_amount: 'Last perchase price',
    b2c_last_sell_amount: 'Last sales price',
  },
  withdrawal: {
    deposit_list: 'Deposit application history',
    withdraw_list: 'Withdrawal application history',
    asset_name: 'Asset name',
    request_price: 'Request amount',
    deposit_inquiry_cancel: 'Inquiry/Cancellation of deposit history',
    withdraw_inquiry_cancel: 'Inquiry/Cancellation of withdrawal history',
    history_detail: 'History Details',
    regdate: 'Application Date',
  },
  myprofile: {
    profile: 'Member information',
    user_name: 'User name',
    email: 'Email',
    regdate: ' Join date',
    last_login: 'Recent login',
    kyc_cert: 'KYC certification',
    kyc_cert_request: 'Application for certification',
    kyc_cert_list: 'Application history',
    pw_modify: 'Password modification',
    old_pw: 'Please enter an existing password',
    new_pw: 'Please enter a new password',
    confirm_pw: 'Confirm password',
    email_modify: 'Modify email',
    new_email: 'Please enter a new email',
    withdrawal: 'Account withdrawal',
    modal_msg: 'Enter your password to resign membership',
    authority: 'self-authentication',
    complete_auth: 'Authentication completed',
    authenticate: 'Authentication',
    uid: 'Member number(UID)',
    email_auth: 'Email authentication',
    auth: 'Authentication',
    auth_code_send: 'Send authentication code',
    auth_code: 'Authentication code',
    auth_code_msg: 'Please enter the authentication code within 5 minutes.',
    otp_auth: 'OTP Authentication',
    enroll: 'Registering',
    security: 'Security rating',
    security_view: 'View security ratings',
    withdraw_auth: 'Withdrawal address authentication',
  },
  kyc: {
    kyc_title: 'KYC certification',
    regdate: 'Registration date',
    expdate: 'Expiration date',
    detail: ' Details',
    type_title: 'Type tile',
    withdraw_auth: 'Withdrawal address authentication',
    select_asset: 'Select asset',
    select_bank: 'Select a bank',
    holder_name: 'Account holder name',
    birth: '6 digits of birth date',
    address: 'Asset address',
    withdraw_list: 'Application history of withdrawal account',
    bank_name: 'Bank Name',
    withdraw_info: 'withdrawal account information',
    withdraw_complete: 'Assets already certified.',
  },
  otp: {
    enter_verification_number: 'Enter OTP authentication number OTP',
    otp_management: 'OTP management',
    authenticode: 'OTP key',
    otp_deactivate: 'OTP deactivate',
    msg_authenticator_installation:
      'Install the "Google Authenticator" app on your smartphone or desktop "Google Authenticator"',
    android: 'Android',
    or: 'Or',
    iphone_series: 'iPhone, iPad and iPod',
    windows_phone: ' Windows Phone',
    and: ', and',
    msg_microsoft_other_systems:
      'Other computers, including Microsoft Windows desktop',
    msg_key: 'This Key',
    msg_use_loss_change:
      ' Please write it down on the paper. It will be used when you lose your device or need to change your OTP.',
    msg_brcode_touch:
      'Launch the Google Authenticator" app and tap <b>Scan QR barcode</b> at the bottom of the screen.',
    msg_input_authenticode:
      'Please enter the authentication code displayed on the screen of the device in the "Authentication Code" column below.',
    otp_key: 'OTP key',
    otp_activate: 'OTP Activation',
    otp_copy: 'The OTP key has been copied.',
    otp_safe_keeping:
      'Did you write down the OTP key on paper and store it in a safe place?',
    yes: 'Yes',
    otp_register: 'Register',
    otp_register_success: 'OTP registration completed successfully.',
    otp_delete_success: 'OTP cancellation registration completed successfully.',
    msg_click_key_copy: 'Click to copy the key.',
    otp_login: 'OTP login',
  },
  security: {
    security_auth: 'Security Authentication',
    grade: 'Rating',
    condition: 'Condition',
    restriction: 'Restrictions',
    no_grade: 'No-rating',
    no: 'None',
    security_title: 'Conditional Limitations by Security Level',
  },
  notice_modal: {
    title: 'Notice',
    content:
      'This is JanoPay who values the assets of the cilents. For smooth transaction stability, we will only proceed with membership registration first, and the transaction commencement date will be notified to customers through a later notice. Thank you.',
    check: 'stop watching today',
  },
  admin: {
    search: 'Search',
    search_word: 'Search word',
    sort: 'Sort',
    desc: 'Descending (DESC)',
    asc: 'Ascending (ASC)',
    reset: 'Reset',
    submit: 'Submit',
    regdate: 'Registration date',
    last_login: 'Recent login',
    search_target: 'Search target',
    user_id: 'ID',
    email_address: 'Email address',
    user_name: 'Name',
    member_seq: 'Member identification number',
    regdate_more: 'Registration date(More)',
    regdate_less: 'Registration date(Less)',
    last_login_more: 'Recent login(More)',
    last_login_less: 'Recent login(Less)',
    no_data: 'None',
    inviter_user_id: 'Inviter ID',
    show_inviter_list: 'View invitees',
    num: 'Number',
    password: 'Password',
    security_level: 'Security level values',
    loading: 'Data is being loaded...',
    ipaddress: 'IP address ',
    user_agent: 'Device information',
    login_log_regdate_more: 'Registration date (More)',
    login_log_regdate_less: 'Registration date (Less)',
    result: 'Result',
    total: 'Total',
    no_search_login: 'Thre is no searched login history.',
    status: 'Status',
    all_show: 'View All',
    market_title: 'Market Title',
    deal_source_amount: 'Amount of disclosed original assets',
    deal_confirmed_source_amount: 'Amount of determined original assets',
    deal_source_max_amount: 'Maximum purchase quantity',
    deal_max_price: 'The Highest asking price',
    source_asset_title: 'Original Asset',
    deal_holding_source_amount: 'Amount of holding original asset',
    deal_potential_source_amount: 'Amount of potential asset',
    deal_source_min_amount: 'Minimum purchase quantity',
    deal_min_price: 'Minimum asking price',
    target_asset_title: 'Target asset',
    source_account: 'Original asset account',
    app_account: 'Buy account',
    fee: 'Fee',
    source_amount: 'Amount of original',
    deal_account: 'Sell account',
    app_price: 'Equity capital',
    close_date: 'Closing date',
    no_limit: '(Unlimited)',
    no_close: '(Unterminated)',
    no_search_deal: 'There is no searched C2C sell disclosure history.',
    no_search_app: 'There is no C2C purchase request history.',
    transfer_type: 'Currency exchange type',
    transfer_asset_pair: 'Asset Pair',
    basic_rate: 'Applicable trading standard rate',
    transfer_source_asset_title: 'Reference Asset',
    transfer_source_account: 'Reference Asset Account',
    exchange_rate: 'Applicable exchange rate',
    transfer_source_amount: 'Amount of reference asset',
    transfer_target_asset_title: 'Relative asset',
    transfer_target_account: 'Relative asset account',
    spread_rate: 'Applied spread rate',
    transfer_target_amount: 'Amount of relative asset',
    no_search_transfer: 'There is no searched currency exchange history.',
    confirm_delete: 'Are you sure you want to delete it?',
    modal_confirm: 'Confirm',
    c2c_market: 'C2C Market Management',
    market_source_min_amount: 'Minimum quantity of original assets',
    market_source_max_amount: 'Maximum quantity of original assets ',
    market_fee_rate: 'Fee Rate',
    market_source_amount_unit: 'Restriction of original asset units',
    is_active: 'Active/Inactive',
    market_no_limit: '(No restrictions)',
    more_zero: 'More 0',
    no_use_cover: '(not used)',
    add: 'Add',
    modify: 'Modify',
    no_c2c_market: 'There is no registered C2C market.',
    direct_transfer_market: 'Exchange (immediate buy/sell) market management',
    direct_basic_rate: 'Trading standard rate',
    direct_bid_spread_rate: 'Buy spread rate',
    direct_allow_bid: 'Permission buy trades',
    direct_ask_spread_rate: 'Sell spread rate',
    direct_allow_ask: 'Permission sell trades',
    no_direct_market: 'There is no registered currency exchange market.',
    b2c_market: 'B2C market management',
    asset_manage: 'Asset management',
    asset_title: 'Asset title',
    asset_code: 'Code',
    modal_asset_code: 'Asset code',
    asset_decimal: 'Decimal places',
    allow_deposit: 'Allow deposit',
    allow_withdraw: 'Allow withdrawal',
    delete: 'Delete',
    no_asset: 'There is no registered assets.',
    asset_plugin: 'Asset plug-in',
    plugin_title: 'Plug-in title',
    plugin: 'Plug-in',
    plugin_select: 'Select plug-in',
    start_block: 'Start block',
    allow_scan: 'Allow scan',
    no_asset_plugin: 'There are no registered asset plug-ins.',
    c2c_market_modify: 'Modification C2C market',
    c2c_market_enroll: 'Registration C2C market',
    direct_market_modify: 'Modification the currency exchange market',
    direct_market_enroll: 'Registration the currency exchange market',
    asset_modify: 'Asset modification',
    asset_enroll: 'Asset registration',
    asset_plugin_modify: 'Modification the asset plug-in',
    asset_plugin_enroll: 'Registration the asset plug-in',
    default_info: 'Default information',
    auto: '(Automatic input)',
    before_enroll: '(Before registration)',
    c2c_market_seq: 'C2C Market unique number',
    c2c_market_regdate: 'First registration date',
    c2c_market_title: 'C2C market title',
    c2c_source_amount_unit: 'Original asset unit',
    save: 'Save',
    enroll: 'Register',
    deal_form: 'Seller add-on form',
    msg_save: 'Do you want to save?',
    msg_enroll: 'Do you want to register?',
    msg_c2c_modify: 'C2C market has been modified.',
    msg_c2c_enroll: 'C2C Market is newly registered.',
    modal_is_active: 'Active',
    allow: 'Restrictions',
    not_allow: 'No restrictions',
    form_info_add: 'Add form',
    form_info_title: 'Form title',
    form_info_list_order: 'Output order',
    form_info_description: 'Please enter a brief description of the form.',
    field_info_name: 'Input space name',
    field_info_title: 'Input space title',
    field_info_description: 'Input space description',
    field_info_is_editable: 'Modifiable',
    field_info_type: 'Input space type',
    field_info_select: 'Option set / Extension',
    field_info_no_space: 'Empty space alternate string',
    field_info_is_required: 'Required',
    field_info_extension_place:
      'Enter supporting extensions separated by commas ',
    no_target: '(Not a target)',
    no_field: 'There is no registered input space.',
    lang_search_select: 'Search and select multiple languages',
    content: 'Content',
    locale: 'Locale',
    new_enroll: 'New registration',
    enroll_lang: 'Registered multilingual',
    value: 'Value',
    no_lang: 'There are no multilingual entries registered.',
    lang_item_name: 'English + numeric characters (first letter English)',
    msg_optionset_delete: 'Are you sure you want to delete the option set?',
    no_optionset: 'Not specifying the option set',
    yes_optionset: '(Specifying the option set)',
    optionset_add: 'Click the <i class="el-icon-plus"></i> button to add',
    optionset_manage: 'Management option set',
    title: 'Title',
    title_admin_place: 'Please enter a title for the administrator.',
    description: 'Description',
    description_admin_place:
      'Please enter a description for the administrator.',
    optionset: 'Options',
    optionset_name: 'Value name',
    msg_direct_market_modify: 'The currency exchange market has been modified.',
    msg_direct_market_enroll:
      'The currency exchange market has been newly registered.',
    direct_market_seq: 'Exchange market unique number',
    msg_asset_modify: 'Asset has been modified.',
    msg_asset_enroll: 'The asset has been newly registered.',
    deposit_form: 'Additional form for depositor',
    withdraw_form: 'Additional form for withdrawer',
    msg_plugin_modify: 'Asset plug-in has been modified.',
    msg_plugin_enroll: 'Asset plug-in is newly registered.',
    asset_plugin_seq: 'Asset plug-in unique number ',
    asset_plugin_name: 'Asset plug-in name',
    asset_plugin_start_block: 'Start block number',
    msg_denied: 'Do you want to reject?',
    msg_denied_success: 'Rejection has been processed.',
    msg_approve: 'Do you want to approve?',
    msg_approve_success: 'Approval has been processed.',
    approve: 'Approve',
    denied: 'Reject',
    no_search_cdd: 'There is no searched CDD certification request history.',
    kyc_type: 'Certification Type',
    kyc_cdd: 'CDD certification request history',
    type: 'Type',
    kyc_is_valid: 'Valid/Invalid',
    valid: 'Valid',
    invalid: 'Invalid',
    kyc_expdate: 'Expiration date',
    no_appoint: '(Unspecified)',
    kyc_cdd_detail: 'CDD Certification request history',
    kyc_cdd_name_id: 'Name(ID)',
    real_name: 'Authenticator real name',
    di: 'Duplicate subscription confirmation value',
    ci: 'Linkage information confirmation value',
    nationality: 'Nationality',
    search_is_valid: 'Search for valid only',
    yes: 'Yes',
    real_name_list: 'Real name authentication history ',
    authority: 'Authentication authority',
    cell_carrier: 'Mobile carrier',
    sex: 'Sex',
    ip_address: 'IP address',
    cell_number: 'Phone number',
    no_search_real_name:
      'There is no searched real-name authentication history.',
    kyc_withdraw_list: 'Asset withdrawal address verification history',
    bank: 'Bank',
    holder_name: 'Holder name',
    withdraw_address: 'Withdraw address',
    no_search_kyc_withdraw:
      'There is no searched asset withdrawal address certification history.',
    restriction_manage: 'Managing restriction policies',
    restriction_list_order: 'Inspection priority',
    restriction_level: 'Level section',
    restriction_title: 'Restriction policie title',
    no_restriction: 'There is no registered restriction policy.',
    level_manage: 'Level management',
    level_list_order: 'Order',
    level: 'Level',
    level_title: 'Level title',
    no_level: 'There is no registered level.',
    restriction_modify: 'Modification restriction policy',
    restriction_enroll: 'Registration restriction policy',
    level_modify: 'Level Modification',
    level_enroll: 'Level Registration',
    msg_restriction_modify: 'Restriction policy has been modified.',
    msg_restriction_enroll: 'Restriction policy is newly registered.',
    msg_delete: 'It has been deleted.',
    msg_save_success: 'It has been saved.',
    msg_enroll_success: 'It has been registered.',
    restriction_target: 'Restricted target',
    restriction_apply: 'Apply restriction policy below',
    restriction_select: '== Select ==',
    no_restriction_target: 'Registered restriction target does not exist.',
    msg_level_modify: 'Level has been modified.',
    msg_level_enroll: 'Level has been newly registered.',
    msg_level_condition: 'All of the following conditions must be met',
    no_level_condition: 'Registered condition does not exist.',
    restriction_target_list: {
      NONE: '{0}',
      CREATE_ACCOUNT: '{0} {1}',
      LIMIT_ASSET_WITHDRAW_ONE_TIME_AMOUNT: '{0} to {1} {2}',
      LIMIT_ASSET_WITHDRAW_DAILY_AMOUNT: '{0} to {1} {2}',
    },
    level_condition_list: {
      NONE: '{0}',
      KYC_CERTIFICATION: '{1} of {0} must be completed',
      KYC_REALNAME: '{0} is required',
      KYC_ASSET_WITHDRAW_ADDRESS_CERTIFICATION:
        '{0} must be completed with {1}',
      MAIL_VERIFICATION: '{0} is required',
      OTP_REGISTER: '{0} is required',
    },
    kyc_certification_type_info: {
      N: '{0}',
      Y: 'Do {0} and valid for {1} seconds',
    },
    account_info: 'Account information',
    account_enroll: 'Register account',
    deposit_address: 'Deposit-only address',
    excel_download: 'Download current results to excel',
    new_account: {
      error: '#NAME?',
    },
    private_key_copy: 'Copy private key',
    no_search_account: 'There is no searched accounts.',
    msg_account: 'Do you want to open?',
    msg_account_modify: 'Account has been modified.',
    msg_account_open: 'Account has been newly opened.',
    request_amount: 'Application amount',
    no_search_deposit: 'There is no searched deposit history.',
    no_search_withdraw: 'There is no searched withdrawal history.',
    deposit_detail: 'Deposit application details',
    withdraw_detail: 'Withdrawal application details',
    withdraw_certification: 'Certification withdrawal information',
    service_msg: 'You can set up settings that are essential for service use.',
    token_secret: 'Token Signing Key',
    token_lifetime: 'Token expiration date',
    default_locale: 'Default locale',
    support_locale: 'Support locale',
    page_display: 'Page exposure',
    use_signup: 'Use sign up',
    is_required: 'Required consent',
    valid_time: 'Valid time',
    sec: 'Second',
    no_kyc_type: 'There is no registered KYC certification type.',
    real_name_setting: 'Real Name authentication settings',
    msg_real_name_setting:
      'Set up settings related to self-authentication and real-name authentication.',
    real_name_authority: 'Real Name authentication authority',
    no_real_name_authority: 'Not used real-name authentication',
    site_code: 'Site code',
    site_pw: 'Site PW',
    exec_path: 'Execution path',
    kyc_type_modify: 'Modification KYC certification type',
    kyc_type_enroll: 'Registration KYC certification type',
    msg_kyc_type_modify: 'The KYC certification type has been modified.',
    msg_kyc_type_enroll: 'KYC certification type is newly registered.',
    kyc_type_title: 'KYC certification type title',
    kyc_type_name: 'Certification type KYC name',
    cdd_valid_time: 'CDD Expiration Date',
    use: 'Use',
    no_use: 'Not used',
    kyc_form: 'Fill out form',
    mail_setting: 'Mail setting',
    msg_mail_setting: 'Set the information to be used when sending mail.',
    default_sender: 'Default sender',
    mail_service: 'Mail service',
    msg_mail_service:
      'Set whether mail is sent or not and settings by service provider.',
    provider: 'Service provider',
    no_send_mail: 'No send mail',
    provider_domain: 'Domain',
    provider_api_key: 'API Key',
    msg_fake:
      'It behaves the same as specifying a provider, and it is recorded in the mail transmission history, but not actually sent.',
    alert_setting: 'Alert setting',
    customer_alert: 'Client (HTML available)',
    admin_alert: 'Administrator (HTML available)',
    replacer: 'Replacer',
    manager: 'Target administrator',
    otp_setting: 'OTP setting',
    msg_otp_setting: 'Make settings related to using OTP.',
    allow_disable_otp: 'Allow cancellation of OTP',
    max_otp_count: 'Maximum number of OTP registrations',
    otp_available_actions: 'OTP available action',
    first_page: 'First Page',
    last_page: 'Last Page',
    cmd_admin_page: 'Manager',
    cmd_brokerage_page: 'Brokerage House',
    shortcuts_today: 'Today',
    shortcuts_yesterday: 'Yesterday',
    shortcuts_thismonth: 'This Month',
    shortcuts_lastmonth: 'Last Month',
    shortcuts_thisweek: 'This Week',
    shortcuts_lastweek: 'Last Week',
    shortcuts_week: 'Last 7 days',
    shortcuts_month: 'Last 30 days',
    msg_balance_adjustment_ask:
      'Do you really want to perform the balance forced adjustment?',
    msg_balance_adjustment_succeed:
      'The balance forced adjustment has been processed successfully.',
    price_change: 'Balance change details',
    balance_adjustment: 'Balance forced adjustment',
    msg_balance_forced_adjustment_info:
      'It can be used when you need to adjust a balance by force, such as recovering the balance due to system errors, test and fraud.',
    msg_balance_forced_adjustment_responsibility:
      'If the balance forced adjustment function is abused or used arbitrarily by an unauthorized person, civil and criminal liability may be imposed.',
    msg_balance_forced_adjustment_error:
      'Unexpected errors can occur after balance forced adjustment.',
    msg_balance_forced_adjustment_carefully:
      'You cannot change the reason information after carry out, so please enter it carefully.',
    adjustment_amount: 'Adjustment Amount',
    increase: 'Increase',
    deduction: 'Deduction',
    reason: 'Reason',
    execution: 'Execution',
    use_statistics_exclude: 'Statistics Exclusion Membership Exclusion',
    connect: 'Connection target',
    all: 'All',
    connection_number: 'Connection target unique number',
    change_history: 'Balance change history',
    performer: 'Performer',
    perfor_ip: 'Performance IP',
    case_name: 'Case Name',
    occurrence_date: 'Occurrence date',
    before_change: 'Balance before change',
    after_change: 'Balance after change',
    explanation: 'Explanation',
    car: 'Car',
    system: 'System',
    not_recorded: 'Not recorded',
    msg_searched_change: 'There is no searched balance change history.',
    account_update_balance_bulk: 'Account balance bulk authority correction',
    msg_excel_warning:
      'When downloading Excel, server overload and browser outage can occur if the amount of data is large. Do you want to run it?',
    msg_accountopen: 'Are you sure you want account normal processing?',
    msg_accountopen_success:
      'Account normal processing has been conducted successfully.',
    msg_accountfraud: 'Are you sure you want account fraud processing?',
    msg_accountfraud_success:
      'Account fraud processing has been conducted successfully.',
    member_is_alive: 'Withdrawal Members Exclusion',
    normal: 'Normal',
    fraud: 'Fraud',
    account_detail: 'Account details',
    as_list: 'As a list',
    from_use_statistics_exclude:
      'Statistics Exclusion Withdrawal Account Members Exclusion',
    to_use_statistics_exclude:
      'Statistics Exclusion Deposit Account Members Exclusion',
    from_member_is_alive: 'Withdrawn Withdrawal Account Member Exclusion',
    to_member_is_alive: 'Withdrawn Deposit Account Member Exclusion',
    msg_search_transfer_list: 'There is no searched transfer history.',
    transfer_list: 'Transfer History',
    role: 'Role',
    select: 'Select',
    msg_grant_roles: 'There are no roles by registered authority.',
    endpoint: 'End Point',
    endpoint_select: 'Select End Point',
    use_script: 'Use Script',
    target: 'Target',
    target_number: 'Target Unique Number',
    activity_log: 'Activity Record',
    system_boxmark: '(System)',
    value_show: 'View Change Value',
    not_recorded_boxmark: '(Not recorded)',
    msg_search_activity_list: 'There is no searched activity record.',
    variable: 'Variable Name',
    before_value: 'Value before change',
    after_value: 'Value after change',
    settlement_amount: 'Settlement Account',
    account_number: 'Account Number',
    msg_adjust_warning:
      'Settlement processing is irreversible. Do you want to run it?',
    msg_adjust_success: 'Allowance balance settlement has been processed.',
    balance_by_asset: 'Allowance balance by asset',
    adjust_success: 'Settlement Processing',
    allowance_adjust_success: 'Allowance settlement processing',
    msg_account_select: 'Please select an account.',
    msg_account_select_no: 'There is no settlable account.',
    account_list: 'Account List',
  },
  relation_list: {
    main_intermediary: '** Main Brokerage House **',
  },
  outsite_transaction_list: {
    sub_broker: 'Sub Brokerage House',
    do_not_select: 'Do not select',
    transaction_history:
      'Transaction history of external site attributable to brokerage house',
    asset_code: 'Asset Code',
    asset_name: 'Asset Name',
    transaction: 'Transaction ID',
    transaction_amount: 'Transaction Amount',
    amount_of_commission: 'Fee Amount',
    profit_and_loss: 'Profit and Loss Amount',
    registration_date: 'Registration Date',
    msg_does_not_exist:
      'There is no external site transaction attributable to the brokerage house.',
  },
  brokerage_member_list: {
    sub_broker: 'Sub Brokerage House',
    not_selecta: 'Do not select',
    msg_not_exist: 'There is no member attributable to the brokerage house.',
  },
  index: {
    broker_information: 'Brokerage House Information',
    control_point: 'Management Place',
    title: 'Title',
    id: 'Owner ID',
    unique_number: 'Brokerage House Unique Number',
    tax_payer_number: 'Taxpayer Number',
    number:
      'SSN, ITIN, Resident Registration Number, Business Registration Number, etc.',
    broker_type: 'Brokerage House Type',
    phone_number: 'Phone Number',
    registration_date: 'Registration Date',
    address: 'Address',
    identification_code: 'Brokerage house identification code',
  },
  withdraw_policy: {
    policy_management: 'Policy Management',
    inspection_priority: 'Inspection Priority',
    act_of_execution: 'Act of Execution',
    title: 'Title',
    msg_no_registration_policy: 'There is no registered policy.',
    summary: 'Summary',
    msg_establish_and_discard:
      'Policies that automate withdrawal approval tasks conditionally can be established and discarded.',
    modification: 'Policy Modification',
    registration: 'Policy Registration',
  },
  pg_feeset: {
    msg_fee_bundle: 'Fee bundle is set by default.',
    fee_bundle_management: 'Fee Bundle Management',
    title: 'Title',
    fee_rate: 'Total Asset Fee Rate',
    basics: 'Basic',
    msg_no_fee: 'There is registered fee bundle.',
    modification: 'Fee Bundle Modification',
    registration: 'Fee Bundle Registration',
  },
  member_view: {
    notification: 'Notification',
    denial_of_service: 'Denial of service',
    existing_password:
      'Succession of existing password when modifying member information in case of blank',
    chief_administrator: 'Chief Administrator',
    authorization: 'Authorization',
    exclude_statistics: 'Statistics Exclusion',
    prevention_of_contamination:
      'Prevention of contamination by excluding from the results of settlement and statistics, etc.',
    security_rating_value: 'Security Level Value',
    fixation: 'Fixation',
    unrated: 'No-level',
    ratinga: 'Registration',
    assigned_groups: 'Assigned Group',
    group_name: 'Group Name',
    group_title: 'Group Title',
    msg_no_group: 'There is no registered group.',
    otp_list: 'OTP List',
    registration_date: 'Registration Date',
    msg_no_otp: 'There is no registered OTP.',
    group_registration: 'Member Group Registration',
    registration: 'Registration',
    membership_group_registration: 'Member Group Registration',
  },
  member_list: {
    seq: 'Member Unique Number',
    user_id: 'ID',
    password: 'Password',
    email_address: 'E-mail',
    user_name: 'Name',
    is_denied: 'Stop or not',
    is_admin: 'Chief administrator or not',
    regdate: 'Registration Date',
    last_login: 'Recent Login',
    is_alive: 'Withdrawal or not',
    deleted_date: 'Withdrawal Date',
    security_level: 'Security Level',
    use_statistics_exclude: 'Statistics Exclusion',
    is_security_level_locked: 'Security rating value fixed or not',
    inviter_seq: 'Recommender Member Unique Number',
    inviter_user_id: 'Recommender member ID 추천자 회원 아이디',
    shortcuts_today: 'Today',
    shortcuts_yesterday: 'Yesterday',
    shortcuts_thismonth: 'This Month',
    shortcuts_lastmonth: 'Last Month',
    shortcuts_thisweek: 'This Week',
    shortcuts_lastweek: 'Last Week',
    shortcuts_week: 'Last 7 days',
    shortcuts_month: 'Last 30 days',
    msg_server_overload:
      'When downloading Excel, server overload and browser outage can occur if the amount of data is large . Do you want to run it?',
    member: 'Member',
    statistics_exclude_members: 'Statistics Exclusion Membership Exclusion',
    chief_administrator: 'Chief Administrator',
    denial_of_service: 'Denial of service',
  },
  member_invite_relation_list: {
    yourself: '** Oneself **',
    area: 'Area(px)',
    designation: 'Designation',
  },
  member_group_list: {
    membership_group: 'Member Group',
    msg_no_membership_group: 'There is no registered member group.',
    group_modification: 'Member Group Modification',
    group_registration: 'Member Group Registration',
  },
  market: {
    fee_rate: 'Sell Discloser Fee Rate',
    requester_fee_rate: 'Buying Requester Fee Rate',
    market_name: 'Market Name',
    market_code: 'Market Code',
    base_assets: 'Base Assets',
    quantity_constructor_commission: 'Quantity Constructor Fee Rate',
    relative_assets: 'Relative Assets',
    quantity_user_fee_rate: 'Quantity User Fee Rate',
    msg_no_registered: 'There is no registered B2C market.',
    modification: 'Open Market Modification',
    registration: 'Open Market Registration',
  },
  finance_catalog: {
    financial_product_management: 'Financial Product Management',
    name: 'Name',
    title: 'Title',
    number_of_subscriptions: 'Number of Subscriptions',
    total_subscription_amount: 'Total Subscription Amount',
    msg_no_registration: 'There is no registered financial product.',
    modification: 'Financial Product Modification',
    registration: 'Financial Product Registration',
  },
  cs_ticket_list: {
    shortcuts_today: 'Today',
    shortcuts_yesterday: 'Yesterday',
    shortcuts_thismonth: 'This Month',
    shortcuts_lastmonth: 'Last Month',
    shortcuts_thisweek: 'This Week',
    shortcuts_lastweek: 'Last Week',
    shortcuts_week: 'Last 7 days',
    shortcuts_month: 'Last 30 days',
    msg_close: 'Are you sure you want to close the inquiry?',
    msg_answer_complete: 'Do you want to process the inquiry as completed?',
    above: 'Registration date (More)',
    less_than: 'Registration date (Less)',
    statistics_exclude_members: 'Statistics Exclusion Membership Exclusion',
    inquiry_history: 'CS Inquiry History',
    statea: 'Status',
    registration_date: 'Registration Date',
    cs_inquiry_id: 'CS Inquiry ID',
    title: 'Title ',
    non_member: '(Non-member)',
    answer_complete: 'Answer Completion',
    close: 'Close',
    contact_request_details: 'CS Inquiry Details',
  },
  cs_faq_list: {
    shortcuts_today: 'Today',
    shortcuts_yesterday: 'Yesterday',
    shortcuts_thismonth: 'This Month',
    shortcuts_lastmonth: 'Last Month',
    shortcuts_thisweek: 'This Week',
    shortcuts_lastweek: 'Last Week',
    shortcuts_week: 'Last 7 days',
    shortcuts_month: 'Last 30 days',
    above: 'Registration date (More)',
    less_than: 'Registration date (Less)',
    registration: 'Registration',
    cs_faq_history: 'CS FAQ History',
    csfaq_number: 'CS FAQ Unique Number',
    csfaq_title: 'CS FAQ Type Name',
    title: 'Title',
    registration_date: 'Registration Date',
    modify: 'Modify',
    csfaq_registration: 'CS FAQ Registration',
    csfaq_modify: 'CS FAQ Modification',
  },
  contract_catalog: {
    managing_contract_documents: 'Contract Document Management',
    name: 'Name',
    title: 'Title',
    document_type: 'Document Type',
    mainly_locale: 'Main Locale',
    registration_date: 'Registration Date',
    msg_no_document: 'There are no registered contract documents.',
    managing_contract_forms: 'Contract Form Management',
    msg_no_forms: 'There is no registered contract form.',
    modifying_document: 'Contract Document Modification',
    register_document: 'Contract Document Registration',
    modifying_forms: 'Contract Form Modification',
    register_forms: 'Contract Form registration',
  },
  config_service: {
    msg_save: 'Do you want to save it?',
    check: 'Confirm',
    second: 'Second',
  },
  config_phone: {
    phone_settings: 'Phone Setting',
    msg_seting: 'Set the information to be used when sending.',
    caller_line_number: 'Caller Line Number ',
    telephone_service: 'Telephone Service',
    msg_set_the_settings:
      'Set whether to send or not and the service provider.',
    do_not_send: 'Do not send',
    msg_not_actually_emit:
      'It behaves the same as if the provider was specified, and is recorded in the call history, but not actually emitted.',
  },
  config_member: {
    msg_save: 'Do you want to save it?',
    check: 'Confirm',
    msg_no_exist: 'This group does not exist',
    login_identifier: 'Login Identifier',
    all_available_identifiers: 'All Available Identifiers',
    enable_allow: 'Using Recommender Allowed Groups',
    acceptance_group: 'Recommender Allowed Groups',
  },
  config_cs: {
    type_of_cs_statement: 'CS Inquiry Type',
    msg_no_cs_statement: 'There is no registered CS inquiry type.',
    cs_faq_type: 'CS FAQ Type',
    type_name: 'Type Name',
    type_namea: 'Type Name',
    msg_no_cs_faq: 'There is no registered CS FAQ Type.',
    modify: 'CS Inquiry Type Modification',
    registration: 'CS Inquiry Type Registration',
    faq_modify: 'CS FAQ Type Modification',
    faq_registration: 'CS FAQ Type Registration',
  },
  brokerage_catalog_relation_list: {
    main_intermediary: '** Main Brokerage House **',
  },
  asset_plugin_list: {
    title: 'Plug In Title',
    scan_status: 'Scan or not',
    plug_ins: 'Assets Plug In List',
  },
  asset_list: {
    asset_code: 'Asset Code',
    active: 'Act or not',
    deposit: 'Deposit Permission',
    withdrawala: 'Withdrawal Permission',
    output_order: 'Output Order',
    asset_list: 'Assets List',
  },
  affiliate_policy: {
    management: 'Allowance Policy Management',
    output_ordera: 'Output Order',
    act: 'Target Act',
    whether_or_not: 'Discharge or not',
    title: 'Title 제목',
    msg_no_allowance: 'There is no registered allowance policy.',
    rectification: 'Allowance Policy Modification',
    registration: 'Allowance Policy Registration',
  },
  acs_catalog: {
    manage_roles: 'Role Management',
    name: 'Name',
    title: 'Title',
    end_point_method: 'End Point Method',
    end_point_path: 'End Point Path',
    msg_no_role: 'There is no registered roles.',
    manage_permissions: 'Manage Authority',
    modify_role: 'Role Modification',
    registering_role: 'Role Registration',
    modify_permissions: 'Authority Modification',
    registration_authority: 'Authority Registration',
  },
  account_update_balance_bulk: {
    msg_account_number:
      'The account number is out of service, so it has been placed on hold.',
    msg_not_exist:
      'It is a deposit-only address that does not exist, so it has been placed on hold.',
    msg_not_match_depositor:
      'The name of the depositor is not matched, so it has been put on hold.',
    choice: '1. Setting and File Selection',
    excel: 'Excel file selection',
    prosecutor: '2. Validation',
    run_account_validation: 'Run account validation',
    msg_before_execution:
      'This is before execution. It must be implemented for correct balance bulk authority correction.',
    msg_execution_completed:
      'Run completed. You can now make a balance bulk authority correction.',
    msg_running:
      'Running. The time required is proportional to the amount of data. Please wait.',
    balance_correction: '3. Balance Correction ',
    current_status: 'Current Status',
    msg_run_button:
      "This is before execution. Click on the 'Run' button to start correcting for balance bulk authority correction.",
    msg_download_excel:
      "Run completed. Please save the results by clicking the 'Download Current Results Excel' button just in case.",
    msg_wait_a_moment:
      'Running. The time required is proportional to the amount of data. Please refrain from moving the page and wait a moment.',
    adjusted_amount: 'Adjustment Amount',
    increase: 'Increase',
    deductinga: 'Deduction',
    reason: 'Reason',
    must_matcm: 'The account holder name must match.',
    practice: 'Practice',
    number: 'Number',
    name: 'Name',
    bank_account_number: 'Account Number',
    deposit_only_addresses: 'Deposit-only Address Handling',
    amount: 'Amount',
    account_number_existence: 'Account number exists or not',
    depositor_name_consistency: 'Exist account holder name or not',
    unique_number: 'Inquired Account Unique Number',
    account_assets: 'Account assets',
    checked_depositor: 'Inquired Account holder name',
    member_unique_number: 'Inquired Member Unique Number',
    state: 'Status',
    result_message: 'Result Message',
    msg_not_exist_excel: 'Excel file not selected or data does not exist.',
  },
  login_me: {
    select_an_intermediary: 'Select Brokerage House',
    shortcuts: 'Shortcuts',
    back: 'Back',
  },
  brokerage_console_main: {
    pr_affiliate: 'Advertisement, Affiliation and Brokerage',
    brokerage_catalog: 'Brokerage House Information',
    sub_broker: 'Sub Brokerage House',
    relation_list: 'Relationship Diagram',
    affiliated_member: 'Affiliated Member',
    external_site_transaction: 'External Site Transaction Details',
    brokerage_balance: 'Brokerage House Balance',
    brokers_equity: 'Brokerage House Share Details',
    brokerage_settlement: 'Brokerage Settlement Details',
  },
  share_list: {
    seq: 'Brokerage House Share Unique Number',
    amount: 'Allowance Amount',
    asset_code: 'Asset Code',
    asset_seq: 'Asset Unique Number',
    asset_title: 'Asset Name',
    base_amount: 'Principal Amount',
    base_amount_target: 'Principal Amount Target',
    benefactor_email_address: 'Benefactor E-mail Address',
    benefactor_member_seq: 'Benefactor Member Unique Number',
    benefactor_type: 'Benefactor Type',
    benefactor_user_id: 'Benefactor User ID',
    benefactor_user_name: 'Benefactor User Name',
    beneficiary_email_address: 'Beneficiary E-mail Address',
    beneficiary_member_seq: 'Beneficiary Member Unique Number',
    beneficiary_type: 'Beneficiary Type',
    beneficiary_user_id: 'Beneficiary User ID',
    beneficiary_user_name: 'Beneficiary User Name',
    causer_email_address: 'Causer E-mail Address',
    causer_seq: 'Causer Member Unique Number',
    causer_user_id: 'Causer User ID',
    causer_user_name: 'Causer User Name',
    log_beneficiary_seq: 'Allowance Accrual Beneficiary Unique Number',
    log_policy_seq: 'Allowance Accrual Policy Unique Number',
    log_seq: 'Allowance Accrual Unique Number',
    policy_amount: 'Allowance amount specified in allowance policy',
    policy_seq: 'Applied Allowance Policy Unique Number',
    policy_title: 'Applied Allowance Policy Title',
    target_action: 'Target Act Type',
    target_seq: 'Target Unique Number',
    affiliate_log_benefactor_seq: 'Allowance Accrual Benefactor Unique Number',
    brokerage_seq: 'Brokerage Unique Number',
    brokerage_title: 'Brokareage House Title',
    inherited_amount: 'Inheritance Amount',
    acquire_rate: 'Acquisition Rate',
    acquire_rate_from_amount: 'Acquisition rate compared to allowance amount',
    acquire_amount: 'Acquisition Amount',
    regdate: 'Registration Date',
    shortcuts_today: 'Today',
    shortcuts_yesterday: 'Yesterday',
    shortcuts_thismonth: 'This Month',
    shortcuts_lastmonth: 'Last Month',
    shortcuts_thisweek: 'This Week',
    shortcuts_lastweek: 'Last Week',
    shortcuts_week: 'Last 7 days',
    shortcuts_month: 'Last 30 days',
    msg_server_overload:
      'When downloading Excel, server overload and browser outage can occur if the amount of data is large. Do you want to run it?',
    equity_history: 'Brokerage House Share Details',
    search: 'Search',
    sub_broker: 'Sub Brokerage House',
    not_select: 'Do not select',
    causer: 'Causer',
    behavior_type: 'Act Type',
    occurrence_date: 'Occurrence Date',
    applied_policy_name: 'Applied Policy Name',
    beneficiary: 'Benefactor',
    allowance_assets: 'Allowance Assets',
    allowance_amount: 'Allowance Amount',
    number: 'Number',
    brokerage_name: 'Brokerage House Name',
    acquisition_rate: 'Acquisition rate compared to allowance amount',
    acquisition_amount: 'Acquisition Amount',
    msg_brokerage_catalog_share_list_no:
      'There is no searched brokerage house share details.',
  },
  child_list: {
    modify_sub_brokerage: 'Modify Sub Brokerage House',
    sub_broker_registration: 'Register Sub Brokerage House',
    List_sub_brokers: 'Sub Brokerage House List',
    new_sub: {
      error: '#NAME?',
    },
    title: 'Title',
    broker_type: 'Brokerage House Type',
    broker_details: 'Brokerage House Details',
    subpoint_registration: 'Sub House Registration',
    msg_no_sub: 'There is no searched sub brokerage house.',
  },
  child_info: {
    msg_wantto_edit: 'Are you sure you want to edit?',
    msg_brokerage_register:
      'Are you sure you want to register a brokerage house?',
    msg_brokerage_modify_success: 'Brokerage has been successfully modified.',
    msg_brokerage_register_success:
      'Brokerage has been successfully registered.',
    brokerage_allowed_not: 'Unable to register sub-brokerage house',
    lowest_broker_type: 'Lowest Brokerage House Type',
    msg_cannot_designate:
      'Brokerage house with cannot be designated as administrative place.',
    control_point: 'Management Place',
    title: 'Title',
    management_poin: 'Management Place Acquisition Rate',
    owner_ID: 'Owner ID',
    broker_number: 'Brokerage House Unique Number',
    payer_number: 'Taxpayer Number',
    number:
      'SN, ITIN, Resident Registration Number, Business Registration Number, etc.',
    broker_type: 'Brokerage House Type',
    phone_number: 'Phone Number',
    rgistration_date: 'Registration Date',
    not_registered: '(Not registered)',
    address: 'Address',
    identification_code: 'Brokerage house identification code',
  },
  withdraw_transfer_list: {
    seq: 'Withdrawal Application Unique Number',
    account_seq: 'Account Unique Number',
    member_seq: 'Member Unique Number',
    user_id: 'ID',
    user_name: 'Name',
    email_address: 'E-mail Address',
    account_number: 'Account Number',
    from: 'Send Address',
    to: 'Incoming Address',
    txid: 'TXID',
    bank_code: 'Bank',
    asset_title: 'Asset Name',
    asset_code: 'Asset Code',
    amount: 'Transfer Amount',
    fee_amount: 'Transfer Fee',
    status: 'Status',
    message: 'Message',
    regdate: 'Registration Date',
    shortcuts_today: 'Today',
    shortcuts_yesterday: 'Yesterday',
    shortcuts_thismonth: 'This Month',
    shortcuts_lastmonth: 'Last Month',
    shortcuts_thisweek: 'This Week',
    shortcuts_lastweek: 'Last Week',
    shortcuts_week: 'Last 7 days',
    shortcuts_month: 'Last 30 days',
    msg_server_overload:
      'When downloading Excel, server overload and browser outage can occur if the amount of data is large. Do you want to run it?',
    withdrawal_transmission: 'Withdrawal Transmission Details',
    statistics_exclude_members: 'Statistics Exclusion Membership Exclusion',
    withdrawal_members_excluded: 'Withdrawal Members Exclusion',
    transmit: 'Transmit',
    receive: 'Receive',
    msg_no_withdrawaa: 'There is no searched withdrawal transfer history.',
  },
  withdraw_policy_info: {
    policy_modified: 'The policy has been modified.',
    policy_registered: 'The policy has been registered.',
    title: 'Title',
    type_of_execution: 'Execution Type',
    choice: 'Select 선택',
    inspection_priority: 'Inspection Priority',
    condition: 'Condition',
    sequence: 'Order',
    must: 'All of the following conditions must be satisfied.',
    msg_no_registered: 'There are no registered conditions.',
  },
  withdraw_list: {
    seq: 'Withdrawal Application Unique Number',
    account_seq: 'Account Unique Number',
    member_seq: 'Member Unique Number',
    withdraw_address_certification_seq:
      'Withdrawal Address Certification Unique Number',
    user_id: 'ID',
    user_name: 'Name',
    email_address: 'E-mail Address',
    account_number: 'Account Number',
    holder_name: 'Account Holder Name',
    bank_code: 'Bank',
    fee_type: 'Fee Charge Type',
    fee_amount: 'Fee Charge Amount',
    net_amount: 'Final Amount',
    asset_title: 'Asset Name',
    asset_code: 'Asset Code',
    request_amount: 'Application Amount',
    status: 'Status',
    regdate: 'Registration Date',
    withdraw_address: 'Withdrawal Certification Address',
    shortcuts_today: 'Today',
    shortcuts_yesterday: 'Yesterday',
    shortcuts_thismonth: 'This Month',
    shortcuts_lastmonth: 'Last Month',
    shortcuts_thisweek: 'This Week',
    shortcuts_lastweek: 'Last Week',
    shortcuts_week: 'Last 7 days',
    shortcuts_month: 'Last 30 days',
    msg_server_overload:
      'When downloading Excel, server overload and browser outage can occur if the amount of data is large. Do you want to run it?',
    withdrawal_application_details: 'Withdrawal Application Details',
    msg_approve: 'Are you sure you want to approve all?',
    msg_reject: 'Are you sure you want to reject all? ',
    msg_approved: "It's been all approved.",
    msg_rejected: "It's been all rejected.",
    statistics_exclude_members: 'Statistics Exclusion Membership Exclusion',
    withdrawal_members_excluded: 'Withdrawal Members Exclusion',
    charging_type: 'Fee Charge Type',
    charge_fee: 'Fee Charge Amount',
    final_amount: 'Final Amount',
    full_approval: 'Full Approval',
    total_deny: 'Full Reject',
    selected_withdrawal: 'Selected Withdrawal Details',
    cancellation: 'Cancel',
    completion: 'Complete',
  },
  withdraw_info: {
    msg_re_transfer:
      '(Re)Transfers can be sent in duplicate. Do you want to run it?',
    notification: 'Notification',
    msg_registered: 'Transfer request has been registered.',
    msg_key_in: 'Key-in the transfer information. Do you want to run it?',
    msg_information: 'Transfer information has been registered.',
    application_details: 'Application Details',
    re_transfer: '(Re) Transfer',
    key_in: 'Transfer Information Key-In',
    amount_transferred: 'Transfer Amount',
    transfer_fee: 'Transfer Fee',
    send_address: 'Send Address',
    incoming_address: 'Incoming Address',
    message: 'Message',
    submission: 'Submit',
    transfer_history: 'Transfer History',
  },
  statistic: {
    shortcuts_today: 'Today',
    shortcuts_yesterday: 'Yesterday',
    shortcuts_thismonth: 'This Month',
    shortcuts_lastmonth: 'Last Month',
    shortcuts_thisweek: 'This Week',
    shortcuts_lastweek: 'Last Week',
    shortcuts_week: 'Last 7 days',
    shortcuts_month: 'Last 30 days',
    category: 'Category',
    property: 'Assets',
    direct: 'Direct Exchange Fee',
    C2C: 'C2C Fee',
    deposit_amount: 'Deposit Amount',
    withdrawal_amount: 'Withdrawal Amount',
    withdrawal_fee: 'Withdrawal Fee',
    announces_sale: 'Sell Discloser',
    purchasing_discloser: 'Buying Discloser',
    msg_not_date:
      'No date is selected or no data matches the selected date interval criteria.',
  },
  public_trade_list: {
    seq: 'Market Closing Unique Number',
    market_seq: 'Open Market Unique Number',
    market_title: 'Open Market Name',
    market_code: 'Open Market Code',
    is_buyer_maker: 'Whether the quantity maker, buyer',
    amount: 'Conclusion Amount',
    price: 'Conclusion Unit Cost',
    maker_member_seq: 'Quantity Maker Member Unique Number',
    maker_user_id: 'Quantity Maker ID',
    maker_user_name: 'Quantity Maker Name',
    maker_email_address: 'Quantity Maker E-mail Address',
    maker_account_seq: 'Quantity Maker Account Unique Number',
    maker_account_number: 'Quantity Maker Account Number',
    maker_order_seq: 'Quantity Maker Order Unique Number',
    maker_fee_amount: 'Quantity Maker Fee',
    taker_member_seq: 'Quantity Taker Member Unique Number',
    taker_user_id: 'Quantity Taker ID',
    taker_user_name: 'Quantity Taker Name',
    taker_email_address: 'Quantity Taker E-mail Address',
    taker_account_seq: 'Quantity Taker Account Unique Number',
    taker_account_number: 'Quantity Taker Address',
    taker_order_seq: 'Quantity Taker Order Unique Number',
    taker_fee_amount: 'Quantity Taker Fee',
    regdate: 'Registration Date',
    shortcuts_today: 'Today',
    shortcuts_yesterday: 'Yesterday',
    shortcuts_thismonth: 'This Month',
    shortcuts_lastmonth: 'Last Month',
    shortcuts_thisweek: 'This Week',
    shortcuts_lastweek: 'Last Week',
    shortcuts_week: 'Last 7 days',
    shortcuts_month: 'Last 30 days',
    msg_server_overload:
      'When downloading Excel, server overload and browser outage can occur if the amount of data is large. Do you want to run it?',
    b2c_engagemen: 'B2C Engagement History',
    except_creator: 'Statistics Exclusion Quantity Maker Exclusion',
    exclude_users: 'Statistics Exclusion Quantity Taker Exclusion',
    b2c_movements: 'B2C Asset Movement History',
    buying: 'Buying',
    sell: 'Sell',
    common: 'Common',
    market_buildera: 'Market Quantity Maker Information',
    market_user: 'Market Quantity Taker Information',
    unique_number: 'Conclusion Unique Number',
    id: 'ID',
    account_number: 'Account Number',
    fee: 'Fee',
    quantity_constructor_status: 'Whether the quantity maker, buyer',
    name: 'Name',
    order_unique_number: 'Order Unique Number',
    msg_no_b2c: 'There is no searched B2C order details.',
  },
  public_order_list: {
    seq: 'Open Market Order Unique Number',
    market_seq: 'Open Market Unique Number',
    market_title: 'Open Market Name',
    market_code: 'Open Market Code',
    account_seq: 'Account Unique Number',
    account_number: 'Account Number',
    user_id: 'ID',
    user_name: 'Name',
    call_price: 'Asking Price',
    call_amount: 'Asking Price Quantity',
    executable_amount: 'Concludable Quantity',
    filled_amount: 'Conclusion Quantity',
    commulative_target_amount: 'Cumulative Relative Asset Quantity',
    is_executable: 'Conclusion availability',
    side_type: 'Transaction Direction',
    status: 'Status',
    closed_date: 'Closing date',
    regdate: 'Registration Date',
    shortcuts_today: 'Today',
    shortcuts_yesterday: 'Yesterday',
    shortcuts_thismonth: 'This Month',
    shortcuts_lastmonth: 'Last Month',
    shortcuts_thisweek: 'This Week',
    shortcuts_lastweek: 'Last Week',
    shortcuts_week: 'Last 7 days',
    shortcuts_month: 'Last 30 days',
    msg_server_overload:
      'When downloading Excel, server overload and browser outage can occur if the amount of data is large. Do you want to run it?',
    b2c_list: 'B2C Order List',
    statistics_exclude_members: 'Statistics Exclusion Membership Exclusion',
    withdrawal_members_excluded: 'Withdrawal Members Exclusion',
    b2c_movements: 'B2C Asset Movement History B2C',
    unique_number: 'Order Unique Number',
    bank_account_number: 'Account Number',
    asking_price: 'Asking Price',
    fastened: 'Concludable Quantity',
    relative: 'Cumulative Relative Asset Quantity',
    transaction_direction: 'Transaction Direction',
    the_asking_price: 'Asking Price Quantity',
    tightening_quantity: 'Conclusion Quantity',
    can_be_fastened: 'Conclusion availability',
    state: 'Status',
    closing_date: 'Closing date',
    unterminated: 'Unterminated',
    msg_no_b2c: 'There is no searched B2C order details.',
  },
  public_market_info: {
    msg_modify: 'It is modified.',
    msg_registered: 'It is registered.',
    market_seq: 'Open Marget Unique Number',
    market_name: 'Market Name',
    code: 'Code',
    allow_deposit: 'Deposit Permission',
    allow_withdrawals: 'Withdrawal Permission',
    output_order: 'Output Order',
    minimum_asking: 'Minimum Asking Price Quantity',
    use: 'Use',
    base_assets: 'Base Assets',
    relative_assets: 'Relative Assets',
    creator: 'Quantity Maker Fee Rate',
    user: 'Quantity Taker Fee Rate',
  },
  public_balance_transfer_list: {
    seq: 'Open Market Balance Transfer Unique Number',
    market_seq: 'Open Market Unique Number',
    market_title: 'Open Market Name',
    market_code: 'Open Market Code',
    user_id: 'ID',
    user_name: 'Name',
    email_address: 'E-mail Address',
    account_number: 'Account Number',
    account_seq: 'Account Unique Number',
    balance_seq: 'Open Market Balance Unique Number',
    transfer_type: 'Transfer Type',
    amount: 'Transfer Quantity',
    regdate: 'Registration Date',
    shortcuts_today: 'Today',
    shortcuts_yesterday: 'Yesterday',
    shortcuts_thismonth: 'This Month',
    shortcuts_lastmonth: 'Last Month',
    shortcuts_thisweek: 'This Week',
    shortcuts_lastweek: 'Last Week',
    shortcuts_week: 'Last 7 days',
    shortcuts_month: 'Last 30 days',
    msg_server_overload:
      'When downloading Excel, server overload and browser outage can occur if the amount of data is large. Do you want to run it?',
    B2C: 'B2C Asset Movement History',
    statistics_exclude_members: 'Statistics Exclusion Membership Exclusion',
    withdrawal_members_excluded: 'Withdrawal Members Exclusion',
    movements: 'B2C Asset Movement History',
    bank_account_number: 'Account Number',
    msg_no_b2c: 'There is no searched B2C transfer details.',
  },
  private_market_info: {
    direct_exchange_market: 'Direct Transfer Market Follow',
    do_not_follow: 'Do not followed.',
    follow: 'Follow',
    choice: 'Select',
    designated: 'The target market is designated as a follow',
    minimum_spread: 'Minimum Spread Ratio',
    maximum_spread: 'Maximum Spread Ratio',
    announces: 'Sell Discloser',
    solicitor: 'Buying Requester',
    safety_type: 'Buying Safety Type',
    msg_immediately:
      'Transactions between the seller and the buyer are made immediately. The transaction speed is the fastest.',
    msg_disclosure:
      "The sell disposer first deposits the assets to be sold to the company and specifies the payment method of the target asset when registering the sale disclosure. The buying requester pays the target asset to the seller in accordance with the target asset payment method specified by the seller. When the buying requester processes the payment complete, the payment suspension is set in the seller's account until the transaction status is resolved.",
    msg_requester:
      "The buying requestor first deposits the assets to be bought to the company and specifies the payment method of the principal asset when registering the buying request. The sell discloser pays the buying requester the principal asset according to the principal asset payment method specified by the buying requestor. When the seller discloser processes the payment complete, the payment suspension is set in the buyer's account until the transaction status is resolved.",
    msg_both_sides:
      'Neither the sell discloser nor the buying requester will deposit. It should only be used when it is judged that there is mutual trust between traders.',
    form: 'Buying Requester Additional Fill-in Form',
  },
  private_deal_list: {
    shortcuts_today: 'Today',
    shortcuts_yesterday: 'Yesterday',
    shortcuts_thismonth: 'This Month',
    shortcuts_lastmonth: 'Last Month',
    shortcuts_thisweek: 'This Week',
    shortcuts_lastweek: 'Last Week',
    shortcuts_week: 'Last 7 days',
    shortcuts_month: 'Last 30 days',
    statistics_exclude_members: 'Statistics Exclusion Membership Exclusion',
    withdrawal_members_excluded: 'Withdrawal Members Exclusion',
  },
  private_application_list: {
    seq: 'Buying Request Unique Number',
    market_seq: 'c2c Market Unique Number',
    market_title: 'c2c Market Name',
    user_id: 'ID',
    user_name: 'Name',
    email_address: 'E-mail Address',
    source_asset_title: 'Source Asset Name',
    source_asset_code: 'Source Asse Code',
    target_asset_title: 'Target Asset Name',
    target_asset_code: 'Target Asset Code',
    deal_seq: 'c2c Sell Disclose Unique Number',
    deal_member_seq: 'c2c Sell Disclose Member Unique Number',
    deal_fee_amount: 'c2c Sell Discloser Fee Amount',
    deal_account_number: 'c2c Sell Account',
    account_number: 'c2c Buying Account',
    account_seq: 'c2c Buying Account Unique Number',
    source_amount: 'Source Asset Quantity',
    fee_amount: 'c2c Buying Requester Fee Amount',
    price: 'Price per Quantity',
    status: 'Status',
    regdate: 'Registration Date',
    shortcuts_today: 'Today',
    shortcuts_yesterday: 'Yesterday',
    shortcuts_thismonth: 'This Month',
    shortcuts_lastmonth: 'Last Month',
    shortcuts_thisweek: 'This Week',
    shortcuts_lastweek: 'Last Week',
    shortcuts_week: 'Last 7 days',
    shortcuts_month: 'Last 30 days',
    msg_change: 'Are you sure you want to change the state?',
    msg_complete: 'The state change is complete.',
    msg_server_overload:
      'When downloading Excel, server overload and browser outage can occur if the amount of data is large. Do you want to run it?',
    c2c_purchase: 'C2C Buying Request Details',
    statistics_exclude_members: 'Statistics Exclusion Membership Exclusion',
    withdrawal_members_excluded: 'Withdrawal Members Exclusion',
    sales_discloser_fee: 'Sell Discloser Fee Amount',
    price_per_quantity: 'Price per Quantity',
    purchase_requeste: 'Buying Requester Fee Amount',
    cancellation: 'cancel',
    Payment: 'payment',
    companion: 'Companion',
    confirmation: 'Confirm',
  },
  pg_transaction_list: {
    seq: 'Transfer Unique Number',
    asset_seq: 'Asset Unique Number',
    user_id: 'ID',
    user_name: 'Name',
    merchant_id: 'Merchant ID',
    merchant_name: 'Merchant Name',
    order_id: 'Merchant Order Number',
    transaction_id: 'Transaction ID',
    feeset_title: 'Application Fee Bundle',
    fee_rate: 'Application Fee Rate',
    fee_amount: 'Charge Fee Rate',
    amount: 'Transaction Amount',
    net_amount: 'Final Settlement Amount',
    refundable_amount: 'Refundable Amount',
    payer_name: 'Payer Name',
    transaction_type: 'Transaction Type',
    status: 'Status',
    regdate: 'Registration Date',
    shortcuts_today: 'Today',
    shortcuts_yesterday: 'Yesterday',
    shortcuts_thismonth: 'This Month',
    shortcuts_lastmonth: 'Last Month',
    shortcuts_thisweek: 'This Week',
    shortcuts_lastweek: 'Last Week',
    shortcuts_week: 'Last 7 days',
    shortcuts_month: 'Last 30 days',
    msg_server_overload:
      'When downloading Excel, server overload and browser outage can occur if the amount of data is large. Do you want to run it?',
    pg_transaction: 'PG Transaction Details',
    statistics_exclude_members: 'Statistics Exclusion Membership Exclusion',
    withdrawal_members_excluded: 'Withdrawal Members Exclusion',
    application_fee: 'Application Fee Bundle',
    transaction_name: 'Transaction Name',
    not_applied: 'Fee bundle not applied',
    no_pg: 'There is no searched PG transaction details.',
  },
  pg_merchant_nav: {
    list: 'As a list',
    information: 'Merchant Information',
  },
  pg_merchant_list: {
    seq: 'Merchant Unique Number',
    member_seq: 'Member Unique Number',
    user_id: 'ID',
    user_name: 'Name',
    email_address: 'E-mail Address',
    merchant_id: 'Merchant ID',
    merchant_name: 'Merchant Name',
    api_signature: 'Merchant Signature',
    status: 'Status',
    msg_server_overload:
      'When downloading Excel, server overload and browser outage can occur if the amount of data is large. Do you want to run it?',
    list_of_stores: 'Merchant List',
    statistics_exclude_members: 'Statistics Exclusion Membership Exclusion',
    withdrawal_members_excluded: 'Withdrawal Members Exclusion',
    store_name: 'Merchant Name',
    registration_date: 'Registration Date',
    store_details: 'Merchant Details',
  },
  pg_merchant_info: {
    store_id: 'Merchant ID',
    store_unique_number: 'Merchant Unique Number',
    store_name: 'Merchant Name',
    application_fee: 'Application Fee Bundle',
    follow_defaul: 'Follow the default specified fee bundle',
    no_default: '[No default specified fee bundle]',
    store_signature_key: 'Merchant Signature',
    automatic_generation: '(Automatic Generation)',
  },
  pg_feeset_info: {
    title: 'Title',
    electronic_property_fee: 'Total Assets Fee Rate',
    fee_by_asset: 'Fees by Asset',
    settlement_assets: 'Payment Asset',
    commission_rate: 'Fee rate',
    msg_no_registered: 'There is no registered fee.',
    choice: 'Select',
  },
  oauth2_client_list: {
    client_information: 'Client Information',
    client_new: 'New Client',
    id: 'Client ID',
    oauth2_client: 'Oauth2 Client',
    new: 'Create New',
    name: 'Client Name',
    secret: 'Client  Secret',
    registration_date: 'Registration Date',
    msg_no_clints: 'There is no registered client.',
  },
  oauth2_client_info: {
    msg_modified: 'Client has been modified.',
    msg_registered: 'Client has been registered.',
    name: 'Client Name',
    id: 'Client ID',
    automatic_generation: '(Automatic Generation)',
    secret: 'Client  Secret',
    url: 'Redirect URI',
    right: 'Authority',
    choice: 'Select',
    msg_not_egistered: 'There is no registered client authority.',
  },
  member_nav: {
    retained: 'Holding OAuth2 Client',
    recommended_relationship: 'Recommended Relationship Diagram',
  },
  member_group_info: {
    msg_modified: 'Member group has been modified.',
    msg_registered: 'Member group has been registered.',
    member_group: 'Member Group Name',
    member_group_name: 'Member Group Name',
    member_output_order: 'Member Output Order',
  },
  member_by_group_info: {
    msg_membership_group: 'Member group has been registered.',
    select_group: 'Group List',
    msg_select_group: 'Please select the group.',
  },
  member_affiliate_policy: {
    msg_completed_successfully:
      'Allowance policy application has been successfully completed.',
    msg_successfully_removed:
      'The Member application allowance policy has been successfully canceled.',
    membership_allowance_policy: 'Member Application Allowance Policy.',
    msg_select: 'Please select an allowance policy to allocate.',
    msg_not_exist: 'There is no allocable allowance policy.',
    application: 'Application',
    act_of_subject: 'Target Act',
    policy_title: 'Policy Title',
    msg_no_allowance: 'There is no allowance policy applied.',
  },
  member_acs_grant: {
    member_applied_acs: 'Member Applicable ACS Authority',
    msg_select_acs: 'Please select the ACS authority to allocate.',
    msg_not_exist: 'There is no allocable ACS authority.',
    application: 'Application',
    privilege_name: 'Authority Name',
    permission_title: 'Authority Title',
    msg_not_have: 'There is no ACS authority applied.',
  },
  loginlog_list: {
    search: 'Search',
    statistics_exclude_members: 'Statistics Exclusion Membership Exclusion',
    withdrawal_members_excluded: 'Withdrawal Members Exclusion',
    msg_successfully:
      'ACS authority application has been successfully completed.',
    msg_revoked:
      'Member applicable ACS authority has been successfully canceled.',
  },
  lang_search_item: {
    elimination: 'Delete',
  },
  kyc_realname_list: {
    kyc_realname_list: 'Today',
    shortcuts_yesterday: 'Yesterday',
    shortcuts_thismonth: 'This Month',
    shortcuts_lastmonth: 'Last Month',
    shortcuts_thisweek: 'This Week',
    shortcuts_lastweek: 'Last Week',
    shortcuts_week: 'Last 7 days',
    shortcuts_month: 'Last 30 days',
    seq: 'Real Name Authentication Unique Number',
    member_seq: 'Member Unique Number',
    user_id: 'ID',
    user_name: 'Name',
    authority: 'Authentication Institution',
    name: 'Real Name Authority Name',
    sex: 'Sex',
    nationality: 'Nationality',
    birth_date: 'Birthday',
    di: 'Duplicate Registration Confirmation Value',
    ci: 'Linked Information Confirmation Value',
    cell_carrier: 'Phone Carrier',
    cell_number: 'Phone Number',
    status: 'Status',
    is_valid: 'Valid or not',
    closed_date: 'Closing Date',
    expdate: 'Expiration Date',
    ipaddress: 'IP Address',
    regdate: 'Registration Date',
    msg_server_overload:
      'When downloading Excel, server overload and browser outage can occur if the amount of data is large. Do you want to run it?',
    real_name: 'Real Name Authority Details',
    statistics_exclude_members: 'Statistics Exclusion Membership Exclusion',
    withdrawal_members_excluded: 'Withdrawal Members Exclusion',
  },
  kyc_certification_info: {
    shortcuts_today: 'Today',
    shortcuts_yesterday: 'Yesterday',
    shortcuts_thismonth: 'This Month',
    shortcuts_lastmonth: 'Last Month',
    shortcuts_thisweek: 'This Week',
    shortcuts_lastweek: 'Last Week',
    shortcuts_week: 'Last 7 days',
    shortcuts_month: 'Last 30 days',
    statistics_exclude_members: 'Statistics Exclusion Membership Exclusion',
    withdrawal_members_excluded: 'Withdrawal Members Exclusion',
  },
  kyc_asset_withdraw_address_certification_list: {
    _no: 'Number',
    seq: 'KYC Asset Withdrawal Address Verification Unique Number',
    asset_seq: 'Asset Unique Number',
    asset_code: 'Asset Code',
    asset_title: 'Asset Name',
    bank_code: 'Bank Code',
    withdraw_address: 'Withdrawal Address',
    holder_name: 'Holder Name',
    member_seq: 'Member Unique Number',
    user_id: 'ID',
    user_name: 'Name',
    email_address: 'E-amil Address',
    status: 'Status',
    is_valid: 'Valid or not',
    regdate: 'Registration Date',
    expdate: 'Expiration Date',
    closed_date: 'Closing Date',
    ipaddress: 'IP Address',
    msg_server_overload:
      'When downloading Excel, server overload and browser outage can occur if the amount of data is large. Do you want to run it?',
    KYC_authentication: 'KYC Withdrawal Address(Account) Authentication',
    statistics_exclude_members: 'Statistics Exclusion Membership Exclusion',
    withdrawal_members_excluded: 'Withdrawal Members Exclusion',
  },
  finance_return_list: {
    seq: 'Allowance Balance Unique Number',
    member_unique_number: 'Member Unique Number',
    id: 'ID',
    name: 'Name',
    email: 'E-mail Address',
    balance: 'Balance',
    cumulative_amount: 'Cumulative Amount',
    first_payment_date: 'Initial Payment Date',
    asset_name: 'Asset Name',
    asset_code: 'Asset Code',
    msg_server_overload:
      'When downloading Excel, server overload and browser outage can occur if the amount of data is large. Do you want to run it?',
    financial_return_history: 'Financial Return History',
    return_account_number: 'Return Account Number',
    fund_account_number: 'Fund Account Number',
    statistics_exclude_members: 'Statistics Exclusion Membership Exclusion',
    withdrawal_members_excluded: 'Withdrawal Members Exclusion',
    financial_instruments_name: 'Financial Product Name',
    return_type: 'Return Type',
    amount: 'Principal Amount',
    principal_amount: 'Principal Amount',
    registration_date: 'Registration Date',
    type_of_financial: 'Financial Product Type',
    patient_type: 'Restitutor Type',
    amount_of_money: 'Interest Amount',
    msg_no_financial: 'There is no searched financial return.',
  },
  finance_nav: {
    setting: 'Setting',
    breakdown_of_funds: 'Fund Details',
    return_history: 'Return History',
    dividend_details: 'Distribution Details',
  },
  finance_instrument_info: {
    title: 'Title',
    description_summary: 'Description Summary',
    type_of_financial: 'Financial Product Type',
    select_product_type: '(Select Product Type)',
    application: 'Application Contract Form',
    select: '(Select Contract Form)',
    name: 'Name',
    executable_asset: 'Execution Assets',
    select_asset: 'Select Assets',
    subscription_start_date: 'Subscription Start Day',
    use: 'Use',
    msg_select_start_date: 'Please select the start day.',
    disable_subscription_start: 'Disable subscription start date',
    end_date: 'Subscription Closing Date',
    msg_select_end_date: 'Please select the closing day.',
    disable_subscription_end: 'Disable subscription closing day.',
    date_of_execution: 'Execution Start Day',
    execute_end: 'Execution Closing Date',
    settlement_date: 'Settlement Start Day',
    execution_amount_bundle: 'Execution Amount bundle',
    join_and_run: 'Subscribe and run in {0} unit',
    msg_execution_asset: 'Please select the execution asset.',
    minimum_amount: 'Minimum Execution Amount',
    disable_minimum: 'Disable minimum execution amount',
    maximum_amount: 'Maximum Execution Amount',
    disable_maximum: 'Disable maximum execution amount',
    profit_for_dividends: 'Financial Product Dividend Profit',
    dividend_profit_assets: 'Dividend Profit Assets',
    dividend_income: 'Dividend Profit Amount',
    choice: 'Select',
    msg_no_benefit: 'There is no registered financial product dividend profit.',
  },
  finance_fund_list: {
    balance_unique_number: 'Allowance Balance Unique Number',
    member_unique_number: 'Member Unique Number',
    id: 'ID',
    name: 'Name',
    email_address: 'E-mail Address',
    balance: 'Balance 잔액',
    accumulated_amount: 'Cumulative Amount',
    first_payment_date: 'Initial Payment Date',
    asset_title: 'Asset Name',
    asset_code: 'Asset Code',
    msg_server_overload:
      'When downloading Excel, server overload and browser outage can occur if the amount of data is large. Do you want to run it?',
    financial_details: 'Financial Fund Details',
    fund_account_number: 'Fund Account Number',
    execution_account_number: 'Execution Account Number',
    statistics_exclude_members: 'Statistics Exclusion Membership Exclusion',
    members_excluded: 'Withdrawal Members Exclusion',
    financial_product: 'Financial Product Name',
    account_number: 'Fund Account Number',
    date_of_execution: 'Execution Start Day',
    execution_amount: 'Execution Amount',
    cancellation_status: 'Cancel or not',
    settlement_start: 'Settlement Start Day',
    financial_instrument: 'Financial Product Type',
    execution: 'Execution Account Number',
    expiry_date: 'Expiration Date',
    completed_or_not: 'Return Complete or not',
    revocation_type: 'Cancellation Type',
    registration_date: 'Registration Date',
    msg_no_financial: 'There is no searched financial fund.',
  },
  direct_transfer_list: {
    exchange_unique_number: 'Exchange Unique Number',
    member_unique_number: 'Member Unique Number',
    rotation_type: 'Exchange Type',
    sales_base_rate: 'Application Sales Base Rate',
    id: 'ID',
    name: 'Name',
    base_assets: 'Base Assets',
    base_assets_account: 'Base Assets Account',
    applied_exchange_rate: 'Application Exchange Rate',
    base_assets_quantity: 'Base Assets Quantity',
    relative_assets: 'Relative Assets',
    relative_asset_account: 'Relative Assets Account',
    relative_asset_quantity: 'Relative Assets Quantity',
    applied_spread_rate: 'Application Spread Rate',
    registration_date: 'Registration Date',
    shortcuts_today: 'Today',
    shortcuts_yesterday: 'Yesterday',
    shortcuts_thismonth: 'This Month',
    shortcuts_lastmonth: 'Last Month',
    shortcuts_thisweek: 'This Week',
    shortcuts_lastweek: 'Last Week',
    shortcuts_week: 'Last 7 days',
    shortcuts_month: 'Last 30 days',
    msg_when_downloading_excel:
      'When downloading Excel, server overload and browser outage can occur if the amount of data is large. Do you want to run it?',
    exchange_details: 'Exchange Details',
    statistics_exclude_members: 'Statistics Exclusion Membership Exclusion',
    withdrawal_members_excluded: 'Withdrawal Members Exclusion',
  },
  deposit_list: {
    seq: 'Deposit Application Unique Number',
    account_seq: 'Account Unique Number',
    member_seq: 'Member Unique Number',
    user_id: 'ID',
    user_name: 'Name',
    email_address: 'E-mail Address',
    account_number: 'Account Number',
    asset_title: 'Asset Name',
    asset_code: 'Asset Code',
    request_amount: 'Application Amount',
    status: 'Status',
    regdate: 'Registration Date',
    shortcuts_today: 'Today',
    shortcuts_yesterday: 'Yesterday',
    shortcuts_thismonth: 'This Month',
    shortcuts_lastmonth: 'Last Month',
    shortcuts_thisweek: 'This Week',
    shortcuts_lastweek: 'Last Week',
    shortcuts_week: 'Last 7 days',
    shortcuts_month: 'Last 30 days',
    msg_excel_warning:
      'When downloading Excel, server overload and browser outage can occur if the amount of data is large. Do you want to run it?',
    msg_approve: 'Are you sure you want to approve all?',
    msg_reject: 'Are you sure you want to reject all?',
    msg_approved: "It's been all approved.",
    msg_rejected: "It's been all rejected.",
    use_statistics_exclude: 'Statistics Exclusion Membership Exclusion',
    member_is_alive: 'Withdrawal Members Exclusion',
    approve: 'Full Approval',
    reject: 'Full Reject',
    deposit_request: 'Deposit Application Details{0}',
    selecte_deposit_history: 'Selected Deposit Details',
    application_amount: 'Application Amount',
    cancel: 'Cancel',
    done: 'Complete',
  },
  contract_form_info: {
    name: 'Name',
    title: 'Title',
    contract_document: 'Contract Document',
    required_consent: 'Required consent or not',
    select: 'Select',
    required: 'Required',
    is_agree_required: 'Require Consent',
    msg_contract_document_no: 'There is no registered contract form document.',
  },
  cs_ticket_type_info: {
    msg_cs_type_modify: 'CS inquiry type has been modified.',
    msg_cs_type_register: 'CS inquiry type has been registered.',
    title: 'CS Inquiry Type Name',
    name: 'CS Inquiry Type Name',
    list_order: 'CS Inquiry Output Order',
    use_content: 'Use CS Inquiry Content',
    allow_guest: 'CS Inquiry non-member Permission',
    use_notify: 'CS Inquiry member Notification Permission',
    use_notify_manager: 'CS Inquiry Manager Notification Permission',
  },
  cs_ticket_info: {
    msg_inquiry_answer: 'Are you sure you want to answer the inquiry?',
    msg_inquiry_answer_success: 'Inquiry has been answered successfully',
    msg_inquiry_ending: 'Are you sure you want to close the inquiry?',
    msg_inquiry_answer_ending:
      'Do you want to process the inquiry as completed?',
    non_member: 'Non-member',
    title: 'Title',
    content: 'Content',
    nodone: '(None)',
    answer: 'Answer',
    answer_register: 'Answer Registration',
    answer_success: 'Answer Completion',
    ending: 'Ending',
  },
  cs_faq: {
    modify: 'Modify',
    register: 'Register',
    msg_cs_modify: 'CS FAQ has been modified.',
    msg_cs_register: 'CS FAQ has been registered.',
    cs_info: 'CS FAQ Information',
    cs_type: 'CS FAQ Type',
    type_selete: 'Select the type',
    title: 'Title',
    content: 'Content',
  },
  cs_faq_type_info: {
    msg_cs_modify: 'CS FAQ type has been modified.',
    msg_cs_register: 'CS FAQ type has been registered.',
    cs_type: 'CS FAQ Type Name',
    cs_type_name: 'CS FAQ Type Name',
  },
  contract_nav: {
    contract_catalog: 'Setting',
    contract_agreement_list: 'Contract Details',
  },
  contract_document_info: {
    document_type: 'Document Type',
    main_locale: 'Main Locale',
    name: 'Name',
    title: 'Title',
    info: 'Description',
    contract_language: 'Contract Language',
    master_locale: 'Main Locale',
    msg_master_locale:
      "The contract document language for is not registered. Click the 'Add' button to complete the registration. We inform you that if you do not register, there can be a legal dispute with the customer in the future.",
    locale: 'Locale',
    content_write: 'Create/Attach Content',
    select: ' Select',
    msg_contract_document_register_no:
      'There is no registered contract document language.',
  },
  brokerage_share_list: {
    seq: 'Brokerage House Share Unique Number',
    amount: 'Allowance Amount',
    asset_code: 'Asset Code',
    asset_seq: 'Asset Unique Number',
    asset_title: 'Asset Name',
    base_amount: 'Principal Amount',
    base_amount_target: 'Principal Amount Target',
    benefactor_email_address: 'Benefactor E-mail Address',
    benefactor_member_seq: 'Benefactor Member Unique Number',
    benefactor_type: 'Benefactor Type',
    benefactor_user_id: 'Benefactor User ID',
    benefactor_user_name: 'Benefactor User Name',
    beneficiary_email_address: 'Beneficiary E-mail Address',
    beneficiary_member_seq: 'Beneficiary Member Unique Number',
    beneficiary_type: 'Beneficiary Type',
    beneficiary_user_id: 'Beneficiary User ID',
    beneficiary_user_name: 'Beneficiary User Name',
    causer_email_address: 'Causer E-mail Address',
    causer_seq: 'Member Unique Number',
    causer_user_id: 'Causer User ID',
    causer_user_name: 'Causer User Name',
    log_beneficiary_seq: 'Allowance Accrual Beneficiary Unique Number',
    log_policy_seq: 'Allowance Accrual Application Policy Unique Number',
    log_seq: 'Allowance Accrual Unique Number',
    policy_amount: 'Allowance amount specified in allowance policy',
    policy_seq: 'Application Allowance Policy Unique Number',
    policy_title: 'Application Allowance Policy Name',
    target_action_type: 'Target Act Type',
    target_seq: 'Target Unique Number',
    affiliate_log_benefactor_seq: 'Allowance Accural Benefactor Unique Number',
    brokerage_seq: 'Brokerage House Unique Number',
    brokerage_title: 'Brokareage House Title',
    inherited_amount: 'Inheritance Amount',
    acquire_rate: 'Acquisition Rate',
    acquire_amount: 'Acquisition Amount',
    regdate: 'Registration Date',
    shortcuts_today: 'Today',
    shortcuts_yesterday: 'Yesterday',
    shortcuts_thismonth: 'This Month',
    shortcuts_lastmonth: 'Last Month',
    shortcuts_thisweek: 'This Week',
    shortcuts_lastweek: 'Last Week',
    shortcuts_week: 'Last 7 days',
    shortcuts_month: 'Last 30 days',
    msg_excel_warning:
      'When downloading Excel, server overload and browser outage can occur if the amount of data is large. Do you want to run it?',
    brokerage_catalog_share_list: 'Brokerage House Share Details{0}',
    search: 'Search',
    use_statistics_exclude: 'Statistics Exclusion Membership Exclusion',
    member_is_alive: 'Withdrawal Members Exclusion',
    target_action: 'Target Act',
    all: 'All',
    target_action_seq: 'Target Act Unique Number',
    causer: 'Causer',
    behavior_type: 'Act Type',
    occurrence_date: 'Occurrence Date',
    applied_policy_name: 'Applied Policy Name',
    benefactor: 'Benefactor',
    allowance_assets: 'Allowance Assets',
    allowance_amount: 'Allowance Amount',
    number: 'Number',
    brokerage_name: 'Brokerage House Name',
    msg_brokerage_catalog_share_list_no:
      'There is no searched brokerage house share details.',
  },
  brokerage_nav: {
    brokerage_list: 'Brokerage House List',
    brokerage_catalog: 'Brokerage Hous Information',
    brokerage_catalog_relation_list: 'Relationship Diagram',
    brokerage_catalog_balance_list: 'Balance by assets',
    brokerage_catalog_share_list: 'Share Details',
    brokerage_catalog_adjust_list: 'Settlement Details',
  },
  brokerage_list: {
    seq: 'Brokerage House Unique Number',
    member_seq: 'Member Unique Number',
    user_id: 'ID',
    user_name: 'Name',
    email_address: 'E-mail Address',
    title: 'Title',
    identification_code: 'Identification Code',
    brokerage_type: 'Brokerage House Type',
    regdate: 'Registration Date',
    msg_excel_warning:
      'When downloading Excel, server overload and browser outage can occur if the amount of data is large. Do you want to run it?',
    brokerage_list: 'Brokerage House List{0}',
    brokerage_modify: 'Brokerage House Modification',
    brokerage_register: 'Brokerage House Registration',
    use_statistics_exclude: 'Statistics Exclusion Membership Exclusion',
    member_is_alive: 'Withdrawal Members Exclusion',
    brokerage_register_new: {
      error: '#NAME?',
    },
    brokerage_detail: 'Brokerage House Details',
    subpoint_registration: 'Sub House Registration',
    msg_search_brokerage_no: 'There is no searched brokerage house.',
  },
  brokerage_info: {
    msg_wantto_edit: 'Are you sure you want to edit?',
    msg_brokerage_register:
      'Are you sure you want to register a brokerage house?',
    msg_brokerage_modify_success: 'Brokerage has been successfully modified.',
    msg_brokerage_register_success:
      'Brokerage has been successfully registered.',
    brokerage_allowed_not: 'Unable to register sub-brokerage house',
    lowest_broker_type: 'Lowest Brokerage House Type',
    msg_cannot_be_designated:
      'Brokerage house with cannot be designated as administrative place.',
    management: 'Management Place',
    title: 'Title',
    management_acquisition: 'Management Place Acquisition Rate',
    target_id: 'Owner ID',
    brokerage_number: 'Brokerage House Unique Number',
    taxpayer_number: 'Taxpayer Number',
    number:
      'SSN, ITIN, Resident Registration Number, Business Registration Number, etc.',
    brokerage_type: 'Brokerage House Type',
    phone_number: 'Phone Number',
    regdate: 'Registration Date',
    unregistered: '(Not registered)',
    address: 'Address',
    brokerage_code: 'Brokerage house identification code',
  },
  brokerage_balance_list: {
    seq: 'Share Balance Unique Number',
    brokerage_title: 'Brokareage House Title',
    amount: 'Balance',
    total_amount: 'Cumulative Amount',
    asset_title: 'Asset Name',
    asset_code: 'Asset Code',
    msg_excel_warning:
      'When downloading Excel, server overload and browser outage can occur if the amount of data is large. Do you want to run it?',
    equity_balances_list: 'Share Balance List',
    msg_adjust_warning:
      'Settlement processing is irreversible. Do you want to run it?',
    msg_balance_settlement_success:
      'Share balance settlement has been processed.',
    equity_balance_asset: 'Share Balance by Assets',
    adjust_success: 'Settlement Processing',
    msg_brokerag_balance_no:
      'There is no searched brokerage house share balance.',
    equity_settlement_processing: 'Share Settlement Processing',
    msg_account_select: 'Please select the account.',
    msg_account_select_no: 'There is no settlement available account.',
    execution: 'Execution',
    brokerage_balance_list:
      'Deal with the settlement of the {2} full amount for {1} share of {0} brokerage house to the account below',
  },
  brokerage_adjust_list: {
    seq: 'Share Balance Unique Number',
    member_seq: 'Member Unique Number',
    user_id: 'ID',
    user_name: 'Name',
    email_address: 'E-mail Address',
    amount: 'Balance',
    total_amount: 'Cumulative Amount',
    regdate: 'Initial Payment Date',
    asset_title: 'Asset Name',
    asset_code: 'Asset Code',
    msg_excel_warning:
      'When downloading Excel, server overload and browser outage can occur if the amount of data is large. Do you want to run it?',
    use_statistics_exclude: 'Statistics Exclusion Membership Exclusion',
    member_is_alive: 'Withdrawal Members Exclusion',
    share_settlement_list: 'Share Settlement Details',
    title: 'Brokerage House Title',
    settlement_amount: 'Settlement Amount',
    account_number: 'Account Number',
    regday: 'Registration Date',
    msg_search_settlement_history_no:
      'There is no searched brokerage house settlement details.',
    share_settlement_history: 'Share Settlement History{0}',
  },
  asset_withdraw_fee: {
    order: 'Order',
    commission: 'Fee',
    withdrawal_commission_same:
      'Same as withdrawal account and fee payment account',
    fee_payment_account_can: 'Fee payment account can be designated separately',
    msg_asset_withdrawal_fee_no: 'There is no registered fund withdrawal fee.',
  },
  asset_info: {
    withdrawal_fee_usage: 'Use Withdrawal Fee',
    msg_withdrawal_fee_done:
      "Please complete the detailed settings in the 'Withdrawal Fee' tab.",
    withdrawal_fee: 'Withdrawal Fee',
  },
  affiliate_policy_info: {
    msg_allowance_policy_modify: 'Allowance Policy has been modified.',
    msg_allowance_policy_register: 'Allowance Policy has been registered.',
    title: 'Title',
    global_coverage: 'Discharge only',
    apply_no: 'Not apply',
    apply_ok: 'Apply',
    target_action: 'Target Act',
    select: 'Select',
    output_order: 'Output Order',
    causer_condition: 'Causer Condition',
    action_condition: 'Target Act Condition',
    beneficiary: 'Beneficiary',
  },
  affiliate_policy_causer_condition: {
    order: 'Order',
    condition_satisfied: 'All of the following conditions must be satisfied.',
    msg_register_occurrence_target_no:
      'There is no registered causer conditions.',
  },
  affiliate_policy_beneficiary: {
    allowance_policy_beneficiary: 'Allowance Policy Beneficiary',
    output_order: 'Output Order',
    beneficiary_type: 'Beneficiary Type',
    beneficiary: 'Beneficiary',
    member_unique_number: 'Member Unique Number',
    relationship_with_originator:
      'Depth of recommended relationship with the causer',
    msg_allowance_policy_no:
      'There is no registered allowance policy beneficiary.',
    allowance_policy_modify: 'Allowance Policy Beneficiary Modification',
    allowance_policy_register: 'Allowance Policy Beneficiary Registration',
  },
  affiliate_policy_beneficiary_info: {
    msg_allowance_policy_modify:
      'Allowance policy beneficiary has been modified.',
    msg_allowance_policy_register:
      'Allowance policy beneficiary has been registered.',
    beneficiary_type: 'Beneficiary Type',
    member_unique_number: 'Member Unique Number',
    referral_depth: 'Depth of recommended relationship',
    output_order: 'Output Order',
    condition: 'Condition',
    benefit: 'Benefactor',
  },
  affiliate_policy_beneficiary_condition: {
    order: 'Order',
    condition_satisfied: 'All of the following conditions must be satisfied.',
    msg_allowance_policy_no:
      'There is no registered allowance policy beneficiary conditions.',
  },
  affiliate_policy_benefactor: {
    order: 'Order',
    benefit: 'Benefactor',
    benefit_type: 'Benefactor Type',
    msg_allowance_policy_no:
      'There is no registered benefactor by allowance policy beneficiary.',
  },
  affiliate_policy_action_condition: {
    order: 'Order',
    condition_satisfied: 'All of the following conditions must be met',
    msg_behavior_conditions: 'There is no registered activity behavior.',
  },
  affiliate_log_list: {
    search: 'Search',
    use_statistics_exclude: 'Statistics Exclusion Membership Exclusion',
    member_is_alive: 'Withdrawal Members Exclusion',
    target_action: 'Target Act',
    all: 'All',
    target_seq: 'Target Act Unique Number',
    payment_history: 'Allowance Accrual History',
    easy_info: 'View as an easy explanation',
    occurrence_target: 'Causer',
    behavior_type: 'Act Type',
    target_unique_number: 'Target Act Unique Number',
    occurrence_date: 'Occurrence Date',
    applied_policy_name: 'Applied Policy Name',
    beneficiary_type: 'Beneficiary Type',
    beneficiary: 'Beneficiary',
    number: 'Number',
    benefit_type: 'Benefactor Type',
    principal_amount_target: 'Principal Amount Target',
    allowance_assets: 'Allowance Assets',
    benefit: 'Benefactor',
    principal_amount: 'Principal Amount',
    allowance_amount: 'Allowance Amount',
    msg_allowance_amount_no: 'There is no searched allowance accrual details.',
    occurrence_info: 'Occurrence Information',
    policy_info: 'Policy Information',
    beneficiary_info: 'Beneficiary Information',
    benefit_info: 'Dispensation Information',
  },
  affiliate_balance_list: {
    seq: 'Allowance Balance Unique Number',
    member_seq: 'Member Unique Number',
    user_id: 'ID',
    user_name: 'Name',
    email_address: 'E-mail Address',
    amount: 'Balance',
    total_amount: 'Cumulative Amount',
    asset_title: 'Asset Name',
    asset_code: 'Asset Code',
    allowance_balances_list: 'Allowance Balance List {0}',
    msg_adjust_to_account:
      'Deal with the settlement of the {2} full amount for {1} allowance of {0} to the account below',
  },
  affiliate_adjust_list: {
    seq: 'Allowance Balance Unique Number',
    member_seq: 'Member Unique Number',
    user_id: 'ID',
    user_name: 'Name',
    email_address: 'E-mail Address',
    amount: 'Balance',
    total_amount: 'Cumulative Amount',
    regdate: 'Initial Payment Date',
    asset_title: 'Asset Name',
    asset_code: 'Asset Code',
    allowance_settlement_list: 'Allowance Settlement details{0}',
  },
  activity_log_list: {
    seq: 'Log Unique Number',
    eventer_seq: 'Performer Unique Number',
    description: 'Log Description',
    ipaddress: 'IP Address',
    user_agent: 'Terminal Information',
    default_locale: 'Basic Locale',
    regdate: 'Registration Date',
    logset_seq: 'Log bundle Unique Number',
    target: 'Target',
    target_seq: 'Target Unique Number',
    reference: 'Reference',
    reference_seq: 'Reference Unique Number',
    logset_description: 'Log Bundle Description',
    user_id: 'User ID',
    email_address: 'E-mail Address',
    user_name: 'Name',
    logset_description_replaced: 'Log Bundle Description Replace Value',
    description_replaced: 'Log Description Replace Value',
    activity_history: 'Activity History{0}',
  },
  account_transfer_list: {
    seq: 'Transfer Application Unique Number',
    asset_seq: 'Fund Unique Number',
    from_seq: 'Withdrawal Account Unique Number',
    to_seq: 'Deposit Account Unique Number',
    amount: 'Transfer Amount',
    from_member_seq: 'Withdrawal Account Member Unique Number',
    to_member_seq: 'Deposit Account Member Unique Number',
    from_account_number: 'Withdrawal Account Number',
    to_account_number: 'Deposit Account Number',
    from_user_name: 'Withdrawal Account Member Name',
    to_user_name: 'Deposit Account Member Name',
    asset_title: 'Asset Name',
    asset_code: 'Asset Code',
    regdate: 'Registration Date',
    from_user_id: 'Withdrawal Account Member ID',
    from_email_address: 'Withdrawal Account Member E-mail',
    to_user_id: 'Deposit Account Member ID',
    to_email_address: 'Deposit Account Member E-mail',
    transfer_request_list: 'Transfer Application History{0}',
  },
  account_list: {
    seq: 'Account Unique Number',
    member_seq: 'Member Unique Number',
    address_seq: 'Deposit Only Address Unique Number',
    user_id: 'ID',
    user_name: 'Name',
    email_address: 'E-mail Address',
    title: 'Account Name',
    account_number: 'Account Number',
    balance: 'Balance',
    status: 'Status',
    regdate: 'Opening Date',
    address: 'Deposit Only Address',
    asset_title: 'Asset Name',
    asset_code: 'Asset Code',
    holding_balance: 'Suspended Amount',
    account_history: 'Account List{0}',
  },
  account_balance_log_list: {
    seq: 'Log Unique Number',
    eventer_seq: 'Performer Unique Number',
    description: 'Log Description',
    ipaddress: 'IP Address',
    user_agent: 'Terminal Information',
    default_locale: 'Basic Locale',
    regdate: 'Registration Date',
    logset_seq: 'Log bundle Unique Number',
    target: 'Target',
    target_seq: 'Target Unique Number',
    reference: 'Reference',
    reference_seq: 'Reference Unique Number',
    logset_description: 'Log Bundle Description',
    user_id: 'User ID',
    email_address: 'E-mail Address',
    user_name: 'Name',
    before: 'Before Value',
    after: 'After Value',
    logset_description_replaced: 'Log Bundle Description Replace Value',
    description_replaced: 'Log Description Replace Value',
    excel_filename: 'Balance Change Details {0}',
  },
  admin_main: {
    sign_out: 'Logout',
    control_panel: 'Control panel',
    board: 'Bulletin board',
    member: 'Member',
    login_list: 'Login history',
    trade: 'Exchange',
    b2c_list: 'B2C order history',
    c2c_deal_list: 'C2C sell disclosure history',
    c2c_app_list: 'C2C Buy Request history',
    transfer_list: 'Exchange history',
    market: 'Market',
    security: 'Security',
    kyc_cdd: 'KYC certification request (CDD)',
    kyc_real_name: 'KYC real name certification',
    kyc_withdraw: 'KYC withdrawal address (account) certification',
    security_restriction: 'Security levels and restriction policies',
    finance: 'Finance',
    account: 'Account',
    deposit_list: 'Deposit history',
    withdraw_list: 'Withdraw history',
    site: 'Site',
    lang: 'Multilingualism',
    setting: 'Setting',
    service: 'Service',
    mail: 'Mail',
    alert: 'Incident notification',
    admin: 'Administrator',
    membership_group: 'Member Group',
    OAuth2_client: 'OAuth2 Client',
    activity_log: 'Activity Record',
    cs_inquiry_history: 'CS Inquiry History',
    contract: 'Contract',
    pr_affiliate: 'Advertisement, Affiliation and Brokerage',
    allowance_policy: 'Allowance Policy',
    benefit_details: 'Allowance Accrual Dispensation/Benefit Details',
    allowance_balance: 'Allowance balance by member assets',
    allowance_settlement: 'Allowance settlement details',
    broker: 'Brokerage House',
    brokerage_balance: 'Brokerage House Balance',
    brokers_equity: 'Brokerage House Share Details',
    brokerage_settlement: 'Brokerage House Settlement Details',
    payment_payment: 'Discharge/Payment',
    store: 'Store',
    fee: 'Fee',
    transaction_history: 'Transaction History',
    asset_management: 'Asset Management',
    plug_in: 'Asset Plug-In Management',
    order_history: 'B2C Order Details',
    engagement_details: 'B2C Engagement History',
    movement_history: 'B2C Asset Movement History',
    financial_management: 'Finance and Fund Management',
    transfer_details: 'Transfer History',
    withdrawal_transmission_history: 'Withdrawal Transfer History',
    withdrawal_policy: 'Withdrawal Policy',
    manageability_access_control: 'Management Function Access Control(ACS)',
    settlement_statistics: 'Settlement and Statistics',
    phone: 'Call',
  },
  admin_member_list: {
    member_list: 'Member list',
    regdate: 'Registration date',
    detail: 'View details',
    no_grade: 'No-level',
    default: 'Default',
    password_msg: 'Modifiable at the site',
    nick_name: 'Nickname',
    birthday: 'birthday',
    list: 'On the list',
    catalog: 'Member information',
    login_log: 'Login history',
    account: 'Holding account',
  },
}
